var _path, _path2, _rect, _g, _rect2, _g2, _rect3, _g3, _path3, _g4, _path4, _g5, _path5, _g6, _path6, _g7, _path7, _g8, _path8, _g9, _path9, _g10, _rect4, _g11, _rect5, _g12, _rect6, _g13, _rect7, _g14, _circle, _circle2, _circle3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect8, _rect9, _g15, _path34, _rect10, _rect11, _rect12, _path35, _path36, _path37, _path38, _path39, _rect13, _rect14, _rect15, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _rect16, _rect17, _g16, _rect18, _path70, _circle4, _path71, _circle5, _path72, _path73, _rect19, _rect20, _path74, _rect21, _path75, _path76, _path77, _circle6, _rect22, _rect23, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _rect24, _rect25, _polyline, _polygon, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _polygon2, _polygon3, _polygon4, _path95, _path96, _path97, _path98, _path99, _path100, _circle7, _circle8, _path101, _path102, _rect26, _path103, _path104, _path105, _path106, _polygon5, _path107, _path108, _path109, _path110, _path111, _path112, _rect27, _path113, _path114, _circle9, _path115;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498.89,116.34S546.42,163.87,630,185c0,0,148.75,40.13,169.87,111.44,0,0,32.19,63.55,8.54,142.86-13.73,46.08-43.52,85.69-83.32,112.65-56.24,38.1-174.94,97.38-354.58,82.35-2.74-.23-5.5-.37-8.25-.39-22.15-.23-142-5.7-238.19-95C77.86,496,51.17,436.06,49,373,45.89,282.47,60.39,138.2,171.46,67.05,171.46,67.05,335.18-55.3,498.89,116.34Z",
    fill: "#13674d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M498.89,116.34S546.42,163.87,630,185c0,0,148.75,40.13,169.87,111.44,0,0,32.19,63.55,8.54,142.86-13.73,46.08-43.52,85.69-83.32,112.65-56.24,38.1-174.94,97.38-354.58,82.35-2.74-.23-5.5-.37-8.25-.39-22.15-.23-142-5.7-238.19-95C77.86,496,51.17,436.06,49,373,45.89,282.47,60.39,138.2,171.46,67.05,171.46,67.05,335.18-55.3,498.89,116.34Z",
    fill: "#fff",
    opacity: 0.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 472.69,
    y: 412.5,
    width: 238.49,
    height: 115.19,
    transform: "translate(-147.21 628.34) rotate(-50.54)",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "480.1 515.34 608.8 358.98 623.23 341.43 670.58 380.4 694.58 400.13 712.18 414.63 610.08 538.67 578.42 577.11 560.61 598.77 543.62 584.78 496.63 546.1 471.68 525.57 480.1 515.34",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.31,457.9c4.22,3.48,2.25,8,.31,12.07l6.13,5a16.16,16.16,0,0,0,2.4-6.27l4.09,1.24a17,17,0,0,1-3.25,7.6l3.36,2.78-2.05,2.48L601.88,480c-4.36,4.32-8.9,4.32-12,1.84-4.22-3.48-2.34-8-.39-12l-6.07-5a15.18,15.18,0,0,0-2.69,8l-4.18-1.16c-.13-2.7,1.33-6.39,3.6-9.5l-3.38-2.78,2.06-2.49,3.39,2.8C586.64,455.35,591.18,455.27,594.31,457.9Zm-1,20.23c1.32,1.11,3.17,1.09,5.27-.79l-5.39-4.44C592.23,475.08,592,477,593.28,478.13Zm-2.47-16.65c-1.32-1.07-3.12-1-5.28,1l5.38,4.41c1-2.24,1.37-4.14-.1-5.38Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M490,513.61a13.26,13.26,0,0,1,1.84,18.67l58.33,48a13.28,13.28,0,0,1,18.62-1.82l125-152A13.26,13.26,0,0,1,692,407.92l-58.33-48,0,0A13.25,13.25,0,0,1,615,361.7L490,513.6ZM666.8,440a3,3,0,0,1-.41-4.28l8.43-10.25h0a3,3,0,0,1,4.28-.42h0a3,3,0,0,1,.42,4.28l-8.44,10.25h0a3,3,0,0,1-4.28.42Zm-91.08,49.73a25.47,25.47,0,0,1-3.44-35.84h0a25.47,25.47,0,1,1,3.47,35.85Zm-71,25.37a3.05,3.05,0,0,1-.37-4.28l8.44-10.27a3,3,0,0,1,4.69,3.87l-8.44,10.26h0a3,3,0,0,1-4.28.42Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "608.78 358.98 670.55 380.4 694.56 400.13 610.05 538.67 578.4 577.12 480.08 515.34 608.78 358.98",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 472.7,
    y: 384.73,
    width: 238.49,
    height: 115.19,
    transform: "matrix(0.5, -0.87, 0.87, 0.5, -87.45, 732.97)",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "483.45 514.77 590.64 329.63 601.85 310.27 650.05 338.19 672.87 351.4 701.53 367.99 615.38 516.8 591.36 558.27 582.03 574.38 482.35 516.67 483.45 514.77",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.26,429.84c4.75,2.73,3.51,7.54,2.27,11.84l6.87,4a16.23,16.23,0,0,0,1.36-6.58l4.24.6a16.91,16.91,0,0,1-1.92,8.1l3.72,2.2-1.61,2.78-3.85-2.23c-3.57,5-8.07,5.74-11.53,3.73-4.73-2.74-3.58-7.5-2.34-11.82l-6.8-3.93a14.94,14.94,0,0,0-1.36,8.3l-4.33-.46c-.47-2.62.29-6.48,2-9.93l-3.72-2.18,1.61-2.79,3.82,2.21C584.34,428.64,588.81,427.8,592.26,429.84Zm1.33,15.05c-.51,2.3-.46,4.26,1,5.1s3.31.54,5.08-1.65l-6.05-3.5ZM589.45,434c-1.46-.84-3.24-.46-5.05,1.76l6,3.48c.61-2.37.7-4.32-1-5.29Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M498.48,501.88A13.25,13.25,0,0,1,503.31,520l65.41,37.87h0A13.27,13.27,0,0,1,586.85,553l98.57-170.27h0a13.27,13.27,0,0,1-4.83-18.12l-65.41-37.87h0a13.26,13.26,0,0,1-18.11,4.83L498.47,501.87ZM660.89,400.49a3,3,0,0,1-1.09-4.14l6.65-11.51h0a3,3,0,0,1,4.15-1.1h0a3,3,0,0,1,1.1,4.16l-6.65,11.49h0a3,3,0,0,1-4.16,1.1Zm-81.71,63.88a25.47,25.47,0,0,1-9.27-34.7l0-.06a25.47,25.47,0,1,1,9.24,34.81Zm-66,36.61a3,3,0,0,1-1-4.17l6.65-11.49.1-.19a3,3,0,0,1,5.16,3.23l-6.65,11.54h0a3,3,0,0,1-4.15,1.11Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "590.64 329.63 650.05 338.18 672.88 351.4 615.38 516.8 591.37 558.27 483.46 514.77 590.64 329.63",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 462.83,
    y: 362.91,
    width: 238.49,
    height: 115.19,
    transform: "translate(-5.1 833.87) rotate(-70.99)",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 462.83,
    y: 362.91,
    width: 238.49,
    height: 115.19,
    transform: "translate(-5.1 833.87) rotate(-70.99)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580,408.19c5.16,1.76,4.91,6.7,4.49,11.17L592,422a16.14,16.14,0,0,0,.07-6.71l4.27-.24a16.91,16.91,0,0,1-.32,8.33l4.12,1.43-1.06,3L595,426.39c-2.55,5.6-6.81,7.21-10.6,5.91-5.16-1.81-5-6.7-4.56-11.17l-7.45-2.57a15.17,15.17,0,0,0,.26,8.42l-4.32.37c-1.07-2.51-1-6.44,0-10.16l-4.13-1.43,1.05-3,4.16,1.43C572,408.55,576.21,406.89,580,408.19Zm4.23,14.52c-.11,2.37.32,4.28,2,4.84s3.35-.11,4.68-2.6l-6.62-2.27ZM578,412.83c-1.6-.55-3.26.17-4.58,2.63l6.58,2.26c.14-2.41-.16-4.33-2-5Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M501.76,496.9A13.27,13.27,0,0,1,510,513.76l71.46,24.62h0a13.25,13.25,0,0,1,16.86-8.22l64.08-186h0a13.27,13.27,0,0,1-8.22-16.87l-71.46-24.61h0a13.27,13.27,0,0,1-16.87,8.22l-64.07,186Zm138-134.57,4.34-12.56a3,3,0,0,1,3.86-1.88h0a3,3,0,0,1,1.88,3.87l-4.32,12.55a3,3,0,0,1-5.76-2Zm-66.1,82.26a25.46,25.46,0,0,1-15.77-32.36h0a25.46,25.46,0,1,1,15.78,32.37Zm-57.6,48.57-.08,0a3,3,0,0,1-1.79-3.87l4.31-12.55.09-.25a3,3,0,0,1,5.66,2.22l-4.36,12.6a3,3,0,0,1-3.87,1.88Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.08,569.76a30.93,30.93,0,0,1,.92-5,30.55,30.55,0,0,1,37.43-21.57,30.6,30.6,0,0,1-38.37,26.62Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.28,
    cy: 488.53,
    r: 30.57,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.28,541.65a30.57,30.57,0,0,1,43.32,43.14l-47-38.69A31.22,31.22,0,0,1,500.28,541.65Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M567.44,600.25a1,1,0,0,1,.08-.3,1.6,1.6,0,0,1,.1-.23.14.14,0,0,0,0-.09.8.8,0,0,1,.15-.21l.13-.18.08-.07.23-.19h0l.2-.11h.08a1,1,0,0,1,.29-.1h59.31a1.86,1.86,0,0,1,1.82,1.9v5.72a1.13,1.13,0,0,1,0,.26h0v.21h0V607h0a.26.26,0,0,1-.09.16h0l-.06.1a.8.8,0,0,1-.13.19h0l-.15.15-.2.15a1.78,1.78,0,0,1-.57.24H569.45a1.88,1.88,0,0,1-1.08-.33,2.17,2.17,0,0,1-.29-.24,1.86,1.86,0,0,1-.56-1.34v-5.67Z",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M567.54,600.24c0-.1.05-.2.08-.3a1.6,1.6,0,0,1,.1-.23.14.14,0,0,0,0-.09.8.8,0,0,1,.15-.21l.13-.18.08-.07.23-.19h0l.22-.11h.09l.25-.1h59.25a1.58,1.58,0,0,1,1.65,2.08v5.72a1.13,1.13,0,0,1,0,.26h0v.41a1.07,1.07,0,0,0-.07.15h0v.08l-.06.1h0a1.3,1.3,0,0,1-.1.15h0l-.15.15-.2.15a1.94,1.94,0,0,1-.57.25H569.35a1.89,1.89,0,0,1-1.08-.34l-.29-.23a1.92,1.92,0,0,1-.54-1.34v-5.68A.87.87,0,0,1,567.54,600.24Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.62,598.6h.08a1.3,1.3,0,0,1,.25-.1h59.26a2,2,0,0,1,1.37.56,2,2,0,0,1,.22,1.65v5.72a1.13,1.13,0,0,1,0,.26h0a.74.74,0,0,1,0,.21h0V607h0v.1h0l-.06.1H617.18a1.07,1.07,0,0,1-1.06-1.06V600A1.16,1.16,0,0,0,615,598.8H568.41Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.61,600.15a1.71,1.71,0,0,1,.09-.3.94.94,0,0,1,.1-.23v-.09a.8.8,0,0,1,.15-.21h12.56a1,1,0,0,1,1,1v6.21h0a1.17,1.17,0,0,0,1.17,1.17h46.55a1.78,1.78,0,0,1-.57.24H569.44a1.86,1.86,0,0,1-1.08-.33,1.68,1.68,0,0,1-.29-.24,1.93,1.93,0,0,1-.55-1.34v-5.67C567.52,600.3,567.52,600.2,567.61,600.15Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.92,606.91a.27.27,0,0,1-.28-.28v-6.77a.3.3,0,0,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.81,606.91a.28.28,0,0,1-.29-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.68,606.91a.28.28,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.6,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.56,606.91a.28.28,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.23.35v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.44,606.91a.28.28,0,0,1-.29-.28v-6.77a.29.29,0,0,1,.3-.29.3.3,0,0,1,.3.29v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.32,606.91a.27.27,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.23.35v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.19,606.91a.28.28,0,0,1-.28-.28v-6.77a.3.3,0,0,1,.59,0v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.07,606.91a.28.28,0,0,1-.29-.28v-6.77h0a.3.3,0,0,1,.6,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,606.91a.27.27,0,0,1-.28-.28v-6.77a.3.3,0,0,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.82,606.91a.28.28,0,0,1-.28-.28v-6.77h0a.3.3,0,0,1,.59,0v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.71,606.91a.28.28,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.3-.29h0a.29.29,0,0,1,.28.29v6.77h0a.28.28,0,0,1-.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.58,606.91a.27.27,0,0,1-.28-.28v-6.77h0a.3.3,0,0,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.47,606.91a.28.28,0,0,1-.29-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77h0a.27.27,0,0,1-.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.34,606.91a.28.28,0,0,1-.29-.28v-6.77h0a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.29v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.22,606.91a.28.28,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77h0a.28.28,0,0,1-.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.1,606.91a.28.28,0,0,1-.29-.28v-6.77h0a.3.3,0,0,1,.6,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577,606.91a.27.27,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.23.35v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.85,606.91a.28.28,0,0,1-.28-.28v-6.77a.3.3,0,0,1,.59,0v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.74,606.91a.28.28,0,0,1-.29-.28v-6.89a.31.31,0,0,1,.36-.23.3.3,0,0,1,.23.35v6.77h0a.28.28,0,0,1-.3.27Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M566.42,590.76a.8.8,0,0,1,.09-.31c0-.09.08-.15.08-.24a.14.14,0,0,0,0-.09l.17-.21a.61.61,0,0,1,.12-.16l.1-.1a1.3,1.3,0,0,1,.23-.18,1.34,1.34,0,0,1,.31-.17h59.21a2.32,2.32,0,0,1,.46.07h0a1.74,1.74,0,0,1,.85.49,1.09,1.09,0,0,1,.23.29,1.84,1.84,0,0,1,.34,1.07v6h0v.39h0a.46.46,0,0,1-.13.2h0v.08h0a.79.79,0,0,1-.17.2,1.09,1.09,0,0,1-.29.23h0a1.52,1.52,0,0,1-.53.25H568.22a2,2,0,0,1-1.37-.56,1.89,1.89,0,0,1-.57-1.35V591A1.64,1.64,0,0,1,566.42,590.76Z",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M566.3,590.73a2.81,2.81,0,0,1,.08-.31c0-.09.09-.15.09-.24a.14.14,0,0,0,0-.09l.16-.21a1,1,0,0,1,.13-.16l.09-.1a1.37,1.37,0,0,1,.24-.18,1.34,1.34,0,0,1,.31-.17h59.36a2.44,2.44,0,0,1,.46.07h0a1.75,1.75,0,0,1,.84.49,1,1,0,0,1,.24.29,1.83,1.83,0,0,1,.33,1.07v5.72a1.13,1.13,0,0,1,0,.26h0a.29.29,0,0,1,0,.13.33.33,0,0,1,0,.14v.12h0l-.06.13a.47.47,0,0,1-.09.12v.08h0a.79.79,0,0,1-.17.2,1.09,1.09,0,0,1-.29.23h0a1.52,1.52,0,0,1-.53.25H568.27a1.91,1.91,0,0,1-1.91-1.91V591A1.31,1.31,0,0,1,566.3,590.73Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.44,589.23h59.43a1.76,1.76,0,0,1,.46.06h0a1.77,1.77,0,0,1,.84.5.92.92,0,0,1,.24.28,1.88,1.88,0,0,1,.33,1.07v5.72a1.13,1.13,0,0,1,0,.26h0a.65.65,0,0,1-.06.21.09.09,0,0,1,0,.07v.12h0l-.06.12-.06.08h0v.07H616.05a1,1,0,0,1-1-1v-6.21a.17.17,0,0,0,0-.07,1.15,1.15,0,0,0-1.23-1.09H567.23A.77.77,0,0,1,567.44,589.23Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.43,590.71a1.58,1.58,0,0,1,.09-.31c0-.09.09-.15.09-.24v-.09l.16-.21h12.56a1.05,1.05,0,0,1,1,1.06v6.2h0a1.17,1.17,0,0,0,1.17,1.17H628a1.52,1.52,0,0,1-.53.25H568.27a1.91,1.91,0,0,1-1.91-1.91V591A2.68,2.68,0,0,1,566.43,590.71Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.69,597.47a.29.29,0,0,1-.23-.34v-6.76a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.81h0a.29.29,0,0,1-.29.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.56,597.47a.29.29,0,0,1-.23-.34v-6.76a.31.31,0,0,1,.3-.3.3.3,0,0,1,.29.3v6.83a.28.28,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.44,597.47a.3.3,0,0,1-.23-.34v-6.88a.31.31,0,0,1,.36-.23.3.3,0,0,1,.23.35v6.81h0a.29.29,0,0,1-.29.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.32,597.47a.29.29,0,0,1-.23-.34v-6.76a.31.31,0,0,1,.29-.3.3.3,0,0,1,.3.3v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.2,597.47a.29.29,0,0,1-.23-.34v-6.76a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.29.29,0,0,1,.23.35v6.81h0a.28.28,0,0,1-.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.07,597.47a.3.3,0,0,1-.23-.34v-6.76a.31.31,0,0,1,.3-.3.31.31,0,0,1,.3.3v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607,597.47a.29.29,0,0,1-.23-.34v-6.76a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.29.29,0,0,1,.23.35v6.83a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.83,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,1,1,.6,0v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.72,597.47a.29.29,0,0,1-.23-.34v-6.76a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.59,597.47a.29.29,0,0,1-.23-.34v-6.76a.31.31,0,0,1,.3-.3.3.3,0,0,1,.29.3v6.83a.28.28,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.46,597.47a.29.29,0,0,1-.23-.34v-6.76h0a.3.3,0,1,1,.6,0v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.35,597.47a.29.29,0,0,1-.23-.34v-6.76h0a.29.29,0,0,1,.3-.3.3.3,0,0,1,.29.3v6.83a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.22,597.47a.29.29,0,0,1-.23-.34v-6.76h0a.29.29,0,0,1,.3-.3.31.31,0,0,1,.3.3v6.83a.28.28,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.11,597.47a.3.3,0,0,1-.24-.34v-6.76a.32.32,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582,597.47a.29.29,0,0,1-.23-.34v-6.76h0a.29.29,0,0,1,.3-.3.3.3,0,0,1,.29.3v6.83a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.86,597.47a.29.29,0,0,1-.23-.34v-6.76a.24.24,0,0,1,0-.12A.3.3,0,0,1,579,590a.3.3,0,0,1,.24.35v6.81h0a.29.29,0,0,1-.29.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.74,597.47a.3.3,0,0,1-.24-.34v-6.76h0a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.62,597.47a.29.29,0,0,1-.23-.34v-6.76a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.29.29,0,0,1,.23.35v6.81h0a.28.28,0,0,1-.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.49,597.47a.29.29,0,0,1-.23-.34v-6.76h0a.3.3,0,1,1,.6,0v6.83a.29.29,0,0,1-.3.27Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M567.72,580.91c0-.07.12-.17.12-.26h0a1.25,1.25,0,0,1,.28-.41l.1-.08.24-.2.31-.16h-.14a.07.07,0,0,1,.09,0H628a1.69,1.69,0,0,1,.45,0,1.91,1.91,0,0,1,1.46,1.86v6.08a.74.74,0,0,1,0,.21l-.07.14a.67.67,0,0,1-.13.25h0v.06a1.24,1.24,0,0,1-.18.22l-.26.2h0a.78.78,0,0,1-.28.16,2.47,2.47,0,0,1-.36.11,1.27,1.27,0,0,1-.39,0H569.44A1.76,1.76,0,0,1,569,589a1.9,1.9,0,0,1-.91-.5,1.71,1.71,0,0,1-.4-.59h0a1.93,1.93,0,0,1-.15-.75v-5.67A1.9,1.9,0,0,1,567.72,580.91Z",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M567.6,580.91c0-.07.11-.17.11-.26h0a1.19,1.19,0,0,1,.16-.23l.13-.18.1-.08.23-.2.31-.16H628a1.77,1.77,0,0,1,.46,0,1.89,1.89,0,0,1,1.45,1.86v5.67a1.61,1.61,0,0,1,0,.31v.1a.37.37,0,0,1,0,.21,1.48,1.48,0,0,1-.12.29h0l-.07.11h0v.06a1.92,1.92,0,0,1-.18.22l-.26.2h0a1.3,1.3,0,0,1-.31.16l-.36.12H569.43a1.69,1.69,0,0,1-.5-.08,1.86,1.86,0,0,1-.87-.5,2,2,0,0,1-.4-.59h0a1.91,1.91,0,0,1-.13-.75v-5.65A1.94,1.94,0,0,1,567.6,580.91Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.51,579.79h59.38a1.77,1.77,0,0,1,.46,0,1.92,1.92,0,0,1,1.45,1.86v5.67a1.61,1.61,0,0,1,0,.31v.1a.74.74,0,0,1,0,.21l-.06.14v.14h0v.08h0v.06H617.18a1.06,1.06,0,0,1-1.06-1.05V581.1h0a1.16,1.16,0,0,0-1.16-1.17H568.41Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.67,580.91c0-.07.12-.17.12-.26h0a.69.69,0,0,1,.16-.23h12.56a1.05,1.05,0,0,1,1,1v6.21h0a1.16,1.16,0,0,0,1.17,1.16h46.55a1.3,1.3,0,0,1-.31.16l-.36.12H569.42a1.67,1.67,0,0,1-.49-.08,1.86,1.86,0,0,1-.87-.5,2,2,0,0,1-.4-.59h0a2.12,2.12,0,0,1-.14-.75v-5.65A2.23,2.23,0,0,1,567.67,580.91Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.92,588a.28.28,0,0,1-.28-.29V581h0a.29.29,0,0,1,.29-.29.29.29,0,0,1,.3.3v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.81,588a.29.29,0,0,1-.29-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.3.3,0,0,1,.23.36v6.76h0a.29.29,0,0,1-.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.68,588a.29.29,0,0,1-.29-.29V581a.3.3,0,0,1,.6,0v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.56,588a.29.29,0,0,1-.28-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.31.31,0,0,1,.23.36v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.44,588a.29.29,0,0,1-.29-.29V581a.29.29,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.32,588a.28.28,0,0,1-.28-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.31.31,0,0,1,.23.36v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.19,588a.29.29,0,0,1-.28-.29V581a.3.3,0,1,1,.59,0v6.76h0a.29.29,0,0,1-.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.07,588a.29.29,0,0,1-.29-.29V581h0a.3.3,0,0,1,.6,0v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,588a.28.28,0,0,1-.28-.29V581a.3.3,0,1,1,.59,0v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.82,588a.29.29,0,0,1-.28-.29V581h0a.3.3,0,0,1,.59,0v6.76h0a.29.29,0,0,1-.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.71,588a.29.29,0,0,1-.29-.29V581a.3.3,0,0,1,.3-.3h0a.3.3,0,0,1,.28.3v6.76h0a.29.29,0,0,1-.29.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.58,588a.28.28,0,0,1-.28-.29V581h0a.29.29,0,0,1,.29-.29.29.29,0,0,1,.3.3v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.47,588a.29.29,0,0,1-.29-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.3.3,0,0,1,.23.36v6.76h0a.28.28,0,0,1-.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.34,588a.29.29,0,0,1-.29-.29V581h0a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.3v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.22,588a.29.29,0,0,1-.28-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.3.3,0,0,1,.23.36v6.76h0a.29.29,0,0,1-.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.1,588a.29.29,0,0,1-.29-.29V581h0a.3.3,0,0,1,.6,0v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577,588a.28.28,0,0,1-.28-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.31.31,0,0,1,.23.36v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.85,588a.29.29,0,0,1-.28-.29V581a.3.3,0,1,1,.59,0v6.76h0a.29.29,0,0,1-.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.74,588a.29.29,0,0,1-.29-.29v-6.88a.31.31,0,0,1,.36-.24.31.31,0,0,1,.23.36v6.76h0a.3.3,0,0,1-.3.28Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M569.71,571.73a.68.68,0,0,1,.07-.2v-.06a2,2,0,0,1,.1-.21,2.09,2.09,0,0,0,.14-.17,1,1,0,0,1,.12-.17.34.34,0,0,0,.09-.08,1,1,0,0,1,.22-.18h0a.82.82,0,0,1,.2-.12h.09l.35-.11h.13a.57.57,0,0,1,.26,0h59a2,2,0,0,1,1,.53,1.88,1.88,0,0,1,.56,1.34v6h0v.27h0a.17.17,0,0,0,0,.1v.13h0a.17.17,0,0,1,0,.1h0a1.44,1.44,0,0,1-.46.46,1.66,1.66,0,0,1-.56.25H571.36a1.92,1.92,0,0,1-1.45-1.86v-5.67A1.75,1.75,0,0,1,569.71,571.73Z",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M569.71,571.67a.68.68,0,0,1,.07-.2v-.06a1,1,0,0,1,.1-.21L570,571a1,1,0,0,1,.12-.16.34.34,0,0,0,.09-.08.76.76,0,0,1,.22-.18h0a1,1,0,0,1,.23-.12h.08a1.57,1.57,0,0,1,.35-.11h59.16a.81.81,0,0,1,.31,0h0a1.91,1.91,0,0,1,1,.53,1.88,1.88,0,0,1,.56,1.34v6h0v.28h0a.17.17,0,0,0,0,.1.35.35,0,0,1-.08.13l-.1.16h0a1.35,1.35,0,0,1-.46.46,1.66,1.66,0,0,1-.56.25H571.24a1.92,1.92,0,0,1-1.46-1.86v-5.67A1.85,1.85,0,0,1,569.71,571.67Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.81,570.51h.09a2,2,0,0,1,.35-.11h59.47a1.94,1.94,0,0,1,1.56,1.88V578a1.13,1.13,0,0,1,0,.26h0a.73.73,0,0,1-.06.21.06.06,0,0,1,0,.06h0a1.34,1.34,0,0,1-.07.18v.06h0l-.09.15H619.54a1.06,1.06,0,0,1-1-1v-6.21h0a1.17,1.17,0,0,0-1.18-1.16h-46.5Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570,571.57a.68.68,0,0,1,.07-.2.06.06,0,0,1,0-.06,1.36,1.36,0,0,1,.1-.21l.14-.18h12.56a1.07,1.07,0,0,1,1,1.06v6.22a1.16,1.16,0,0,0,1.17,1.16h46.54a1.66,1.66,0,0,1-.56.25H571.36a1.92,1.92,0,0,1-1.45-1.86v-5.67A1.71,1.71,0,0,1,570,571.57Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.29,578.58a.28.28,0,0,1-.28-.28v-6.77a.3.3,0,0,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.16,578.58a.29.29,0,0,1-.28-.28v-6.77h0a.3.3,0,1,1,.59,0v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.05,578.58a.29.29,0,0,1-.29-.28v-6.77h0a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.92,578.58a.28.28,0,0,1-.28-.28v-6.77h0a.3.3,0,1,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.81,578.58a.29.29,0,0,1-.29-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.29.29,0,0,1,.23.35v6.77h0a.28.28,0,0,1-.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.68,578.58a.29.29,0,0,1-.29-.28v-6.77h0a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.56,578.58a.29.29,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77h0a.29.29,0,0,1-.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.44,578.58a.29.29,0,0,1-.29-.28v-6.77h0a.3.3,0,1,1,.6,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.32,578.58a.28.28,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.19,578.58a.29.29,0,0,1-.28-.28v-6.77h0a.3.3,0,1,1,.59,0v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.08,578.58a.29.29,0,0,1-.29-.28v-6.89a.31.31,0,0,1,.36-.23.3.3,0,0,1,.23.35v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595,578.58a.28.28,0,0,1-.28-.28v-6.77a.3.3,0,0,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.84,578.58a.29.29,0,0,1-.29-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.29.29,0,0,1,.23.35v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.71,578.58a.29.29,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.6,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.58,578.58a.28.28,0,0,1-.28-.28v-6.77a.3.3,0,0,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.4,578.58a.29.29,0,0,1-.28-.28v-6.77a.29.29,0,0,1,.3-.29.31.31,0,0,1,.3.29v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.34,578.58a.29.29,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.29v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.2,578.58a.29.29,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.29v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.1,578.58a.29.29,0,0,1-.29-.28v-6.77h0a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.77h0a.28.28,0,0,1-.3.27Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M569.81,562.3a.79.79,0,0,1,.06-.22.14.14,0,0,1,0-.09l.07-.17a.29.29,0,0,1,.08-.13,1.28,1.28,0,0,1,.14-.21.61.61,0,0,1,.12-.16l.1-.09a1.59,1.59,0,0,1,.24-.2l.31-.16h59.38a1.92,1.92,0,0,1,1.91,1.91v5.67a1.6,1.6,0,0,1,0,.31v.1a.81.81,0,0,1,0,.22.35.35,0,0,1-.06.14,1.51,1.51,0,0,1-.11.22v.06h0a1,1,0,0,1-.18.22,1.28,1.28,0,0,1-.26.2h0a.65.65,0,0,1-.27.15l-.36.12H571.77a.57.57,0,0,1-.26,0h0a2,2,0,0,1-1-.53,1.92,1.92,0,0,1-.56-1.35v-5.66A1.54,1.54,0,0,1,569.81,562.3Z",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M570,562.3a.79.79,0,0,1,.06-.22.14.14,0,0,1,0-.09l.08-.17a.24.24,0,0,1,.07-.13,1.28,1.28,0,0,1,.14-.21,1,1,0,0,1,.12-.16l.1-.09a1.59,1.59,0,0,1,.24-.2l.31-.16h59.18a1.91,1.91,0,0,1,1.91,1.91v5.68a1.6,1.6,0,0,1,0,.31v.09a.81.81,0,0,1,0,.22,1,1,0,0,1-.11.27l-.1.15h0a.72.72,0,0,1-.17.22,1.64,1.64,0,0,1-.26.2h0a.85.85,0,0,1-.3.15l-.36.12H571.37a1.92,1.92,0,0,1-1.56-1.88v-5.66A1.58,1.58,0,0,1,570,562.3Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17,560.8h59.18a1.91,1.91,0,0,1,1.91,1.91V569a1,1,0,0,1-.07.15.24.24,0,0,1,0,.12l-.06.09a.41.41,0,0,1-.07.11H619.54a1,1,0,0,1-1-1.05v-6.23a1.17,1.17,0,0,0-1.18-1.16H570.78Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570,562.31a.79.79,0,0,1,.06-.22.14.14,0,0,1,0-.09l.08-.17a.24.24,0,0,1,.07-.13,1.28,1.28,0,0,1,.14-.21h12.56a1.07,1.07,0,0,1,1,1.06v6.2h0a1.17,1.17,0,0,0,1.17,1.17h46.54a.85.85,0,0,1-.3.15l-.36.12H571.47a1.92,1.92,0,0,1-1.56-1.88v-5.66A1.86,1.86,0,0,1,570,562.31Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629,568.85v-6.76a.3.3,0,1,1,.59,0v6.76a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.88,568.85v-6.76h0a.3.3,0,1,1,.59,0v6.76a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.76,568.85v-6.76a.3.3,0,0,1,.6,0v6.76a.29.29,0,0,1-.3.3A.3.3,0,0,1,622.76,568.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.64,568.85v-6.76h0a.3.3,0,1,1,.59,0v6.76a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.52,568.85v-6.76a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.76h0a.28.28,0,0,1-.28.29A.29.29,0,0,1,616.52,568.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.39,568.85v-6.76h0a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3v6.76a.29.29,0,0,1-.3.3A.3.3,0,0,1,613.39,568.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.28,568.85v-6.76a.24.24,0,0,1,0-.12.29.29,0,0,1,.35-.23.3.3,0,0,1,.23.35v6.76h0a.29.29,0,0,1-.28.29A.29.29,0,0,1,610.28,568.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.15,568.85v-6.76h0a.3.3,0,0,1,.6,0v6.76a.3.3,0,0,1-.3.3A.29.29,0,0,1,607.15,568.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.31,569.15a.28.28,0,0,1-.27-.3v-6.76a.24.24,0,0,1,0-.12.29.29,0,0,1,.35-.23.3.3,0,0,1,.23.35v6.76a.29.29,0,0,1-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.91,568.85v-6.76h0a.3.3,0,1,1,.59,0v6.76a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.07,569.15a.3.3,0,0,1-.28-.3V562a.3.3,0,0,1,.59.12v6.76a.3.3,0,0,1-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.67,568.85v-6.76a.3.3,0,1,1,.59,0v6.76a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.82,569.15a.29.29,0,0,1-.27-.3v-6.76a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.76a.29.29,0,0,1-.29.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.42,568.85v-6.76a.3.3,0,0,1,.6,0v6.76a.29.29,0,0,1-.3.3A.3.3,0,0,1,588.42,568.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.3,568.85v-6.76a.3.3,0,1,1,.59,0v6.76a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.12,568.85v-6.76a.29.29,0,0,1,.3-.3.31.31,0,0,1,.3.3v6.76a.3.3,0,0,1-.3.3A.29.29,0,0,1,582.12,568.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.05,568.85v-6.76a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3v6.76a.29.29,0,0,1-.3.3A.3.3,0,0,1,579.05,568.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.91,568.85v-6.76a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3v6.76a.29.29,0,0,1-.3.3A.3.3,0,0,1,575.91,568.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.81,568.85v-6.76a.29.29,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.76a.3.3,0,0,1-.6,0Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M565.1,552.73a.85.85,0,0,1,.09-.31,1.17,1.17,0,0,1,.09-.24.11.11,0,0,0,0-.08l.15-.21a.7.7,0,0,1,.13-.16.32.32,0,0,0,.08-.09,1.3,1.3,0,0,1,.23-.18h0a.94.94,0,0,1,.22-.12h0l.31-.1h59.2a1.76,1.76,0,0,1,.46.06,1.87,1.87,0,0,1,.9.5,1.28,1.28,0,0,1,.23.29,1.78,1.78,0,0,1,.34,1v6.19h0v.21h0a.7.7,0,0,1-.08.2.49.49,0,0,1-.11.2h0V560h0a.56.56,0,0,1-.16.21,1.81,1.81,0,0,1-.3.25h0a1.78,1.78,0,0,1-.58.26H567.09a1.91,1.91,0,0,1-1.92-1.91v-5.67A1.14,1.14,0,0,1,565.1,552.73Z",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M565.1,552.72a1.58,1.58,0,0,1,.09-.31,1.17,1.17,0,0,1,.09-.24.11.11,0,0,0,0-.08l.15-.22a1.83,1.83,0,0,1,.13-.16.2.2,0,0,0,.08-.08.76.76,0,0,1,.23-.18h0a1,1,0,0,1,.23-.12h0l.31-.1h59.21a1.61,1.61,0,0,1,.49.07,1.71,1.71,0,0,1,.86.5,1.68,1.68,0,0,1,.24.29,1.84,1.84,0,0,1,.33,1V559a1.13,1.13,0,0,1,0,.26h0a.29.29,0,0,1,0,.13.2.2,0,0,1,0,.11.68.68,0,0,1-.07.2.29.29,0,0,0,0,.13l-.09.12V560h0a.56.56,0,0,1-.16.21,2.34,2.34,0,0,1-.3.25h0a1.88,1.88,0,0,1-.58.26H567.13a1.84,1.84,0,0,1-1.36-.56,1.91,1.91,0,0,1-.55-1.35v-5.67A3.31,3.31,0,0,1,565.1,552.72Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.12,551.33h0l.31-.1h59.21a1.68,1.68,0,0,1,.5.07,1.64,1.64,0,0,1,.85.5,1.68,1.68,0,0,1,.24.29,1.78,1.78,0,0,1,.34,1v6.19h0a1,1,0,0,1-.07.21h0a.68.68,0,0,1-.07.2.29.29,0,0,0,0,.13l-.06.07h0V560H614.81a1.06,1.06,0,0,1-1.06-1v-6.2h0a1.16,1.16,0,0,0-1.16-1.17H566.05A.77.77,0,0,1,566.12,551.33Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.24,552.87a1.58,1.58,0,0,1,.09-.31.5.5,0,0,1,.09-.24v-.09l.14-.21h12.58a1.06,1.06,0,0,1,1,1.06v6.23a1.16,1.16,0,0,0,1.18,1.15h46.52a1.78,1.78,0,0,1-.58.26H567.09a1.8,1.8,0,0,1-1.35-.56,1.88,1.88,0,0,1-.56-1.35v-5.67Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M624.31,559.41v-6.77a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.29v6.77a.3.3,0,0,1-.3.3A.31.31,0,0,1,624.31,559.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.15,559.41v-6.77h0a.3.3,0,0,1,.3-.3.31.31,0,0,1,.3.3v6.77a.31.31,0,0,1-.3.3A.3.3,0,0,1,621.15,559.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618,559.41v-6.77a.3.3,0,0,1,.6,0v6.77a.3.3,0,1,1-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.91,559.41v-6.77h0a.3.3,0,0,1,.3-.3.31.31,0,0,1,.29.3v6.77a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.78,559.41v-6.77a.29.29,0,0,1,.3-.29.31.31,0,0,1,.3.29v6.77a.31.31,0,0,1-.3.3A.3.3,0,0,1,611.78,559.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.66,559.41v-6.89a.31.31,0,0,1,.36-.23.3.3,0,0,1,.23.35v6.77h0a.29.29,0,0,1-.29.29A.31.31,0,0,1,608.66,559.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.54,559.41v-6.77a.3.3,0,0,1,.59,0v6.77a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.42,559.41v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.59.12v6.77h0a.29.29,0,0,1-.29.29A.31.31,0,0,1,602.42,559.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.3,559.41v-6.77a.3.3,0,0,1,.59,0v6.77a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.45,559.71a.29.29,0,0,1-.27-.3v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77a.3.3,0,0,1-.29.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.05,559.41v-6.77a.3.3,0,0,1,.6,0v6.77a.3.3,0,0,1-.3.3A.31.31,0,0,1,593.05,559.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.21,559.71a.28.28,0,0,1-.27-.3v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.23.35v6.77a.3.3,0,0,1-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.81,559.41v-6.77a.29.29,0,0,1,.3-.29.3.3,0,0,1,.3.29v6.77a.31.31,0,0,1-.3.3A.3.3,0,0,1,586.81,559.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584,559.71a.28.28,0,0,1-.27-.3v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.23.35v6.77a.3.3,0,0,1-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.57,559.41v-6.77a.3.3,0,0,1,.59,0v6.77a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.44,559.41v-6.77h0a.31.31,0,0,1,.3-.3.31.31,0,0,1,.3.3v6.77a.31.31,0,0,1-.3.3A.3.3,0,0,1,577.44,559.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.33,559.41v-6.77a.3.3,0,0,1,.59,0v6.77a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.2,559.41v-6.77h0a.3.3,0,0,1,.3-.3.31.31,0,0,1,.29.3v6.77a.3.3,0,1,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.08,559.41v-6.89a.31.31,0,0,1,.36-.23.3.3,0,0,1,.23.35v6.77h0a.29.29,0,0,1-.29.29A.31.31,0,0,1,568.08,559.41Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M567.72,543.09c0-.08.12-.18.12-.26h0a1.12,1.12,0,0,1,.28-.4l.1-.1.24-.19.31-.16H628a1.92,1.92,0,0,1,1.9,1.93V550a.74.74,0,0,1,0,.21.47.47,0,0,1-.07.12.55.55,0,0,1-.13.25h0v.06a2,2,0,0,1-.46.45,1.8,1.8,0,0,1-.57.25H569.4a1.76,1.76,0,0,1-.46-.06h0a2,2,0,0,1-.87-.5,1.66,1.66,0,0,1-.4-.61h0a1.88,1.88,0,0,1-.15-.74v-5.67A1.64,1.64,0,0,1,567.72,543.09Z",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M567.63,543.08c0-.08.11-.18.11-.26h0a1,1,0,0,1,.16-.24.61.61,0,0,0,.12-.16l.1-.1.24-.19.31-.16H628a1.91,1.91,0,0,1,1.9,1.93v5.67a1.61,1.61,0,0,1,0,.31v.1a.74.74,0,0,1,0,.21,1.39,1.39,0,0,1-.12.28h0l-.08.12h0v.06a2.18,2.18,0,0,1-.46.45,1.92,1.92,0,0,1-.57.24H569.39a1.76,1.76,0,0,1-.46-.06h0a1.86,1.86,0,0,1-.87-.5,2,2,0,0,1-.4-.6h0a1.86,1.86,0,0,1-.13-.74v-5.65A1.7,1.7,0,0,1,567.63,543.08Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.51,542H627.9a1.91,1.91,0,0,1,1.9,1.92v5.67a1.6,1.6,0,0,1,0,.31v.1a.74.74,0,0,1,0,.21.31.31,0,0,1-.06.13v.16h0v.06h0v.06H617.18a1.06,1.06,0,0,1-1.06-1.05v-6.21h0a1.17,1.17,0,0,0-1.16-1.17H568.41Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.67,543.14c0-.08.12-.18.12-.26h0a.78.78,0,0,1,.16-.24h12.56a1.07,1.07,0,0,1,1,1.06v6.2h0a1.17,1.17,0,0,0,1.17,1.17h46.55a2.06,2.06,0,0,1-.57.25H569.39a1.77,1.77,0,0,1-.46-.07h0a1.84,1.84,0,0,1-.87-.49,2.22,2.22,0,0,1-.4-.61h0a1.83,1.83,0,0,1-.14-.73v-5.66A2.09,2.09,0,0,1,567.67,543.14Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.64,550v-6.77a.29.29,0,0,1,.29-.29.29.29,0,0,1,.3.29V550a.29.29,0,0,1-.3.3A.28.28,0,0,1,626.64,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.52,550v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.29.29,0,0,1,.23.35V550a.29.29,0,0,1-.29.3A.29.29,0,0,1,623.52,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.39,550v-6.77a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.29V550a.3.3,0,0,1-.3.3A.3.3,0,0,1,620.39,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.28,550v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12V550a.29.29,0,0,1-.3.3A.29.29,0,0,1,617.28,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.15,550v-6.77a.3.3,0,0,1,.6,0V550a.3.3,0,0,1-.3.3A.3.3,0,0,1,614.15,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,550v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12V550a.29.29,0,0,1-.3.3A.28.28,0,0,1,611,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.91,550v-6.77a.29.29,0,0,1,.29-.29.29.29,0,0,1,.3.29V550a.3.3,0,0,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.78,550v-6.77h0a.3.3,0,0,1,.6,0V550a.3.3,0,0,1-.3.3A.3.3,0,0,1,604.78,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.67,550v-6.77a.29.29,0,0,1,.29-.29.29.29,0,0,1,.3.29V550a.29.29,0,0,1-.3.3A.28.28,0,0,1,601.67,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.54,550v-6.77h0a.3.3,0,1,1,.59,0V550a.3.3,0,0,1-.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.42,550v-6.77a.31.31,0,0,1,.3-.3h0a.3.3,0,0,1,.28.3V550a.29.29,0,0,1-.29.28A.3.3,0,0,1,595.42,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.3,550v-6.77h0a.3.3,0,1,1,.59,0V550a.29.29,0,0,1-.3.3A.28.28,0,0,1,592.3,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.18,550v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.29.29,0,0,1,.23.35V550a.28.28,0,0,1-.28.28A.3.3,0,0,1,589.18,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.05,550v-6.77h0a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3V550a.3.3,0,0,1-.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.94,550v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.29.29,0,0,1,.23.35V550a.29.29,0,0,1-.28.28A.3.3,0,0,1,582.94,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.81,550v-6.77h0a.3.3,0,0,1,.6,0V550a.3.3,0,0,1-.3.3A.3.3,0,0,1,579.81,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.7,550v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12V550a.29.29,0,0,1-.3.3A.28.28,0,0,1,576.7,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.57,550v-6.77a.29.29,0,0,1,.3-.29.28.28,0,0,1,.29.29V550a.29.29,0,0,1-.29.3A.3.3,0,0,1,573.57,550Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.45,550v-6.89a.31.31,0,0,1,.36-.23.3.3,0,0,1,.23.35V550a.3.3,0,0,1-.3.3A.29.29,0,0,1,570.45,550Z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 638.56,
    y: 598.5,
    width: 62.6,
    height: 9.51,
    rx: 1.92,
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M639,599.27a1.84,1.84,0,0,1,1.51-.77h58.76a1.93,1.93,0,0,1,1.92,1.94v5.72a1.8,1.8,0,0,1-2,1.85H640.47a1.92,1.92,0,0,1-1.91-1.92v-5.65A1.85,1.85,0,0,1,639,599.27Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.75,607.22H688.19a1,1,0,0,1-1.05-1V600h0a1.17,1.17,0,0,0-1.17-1.17H639.42a1.88,1.88,0,0,1,1.05-.32h58.78a1.92,1.92,0,0,1,1.9,1.92v5.66A1.83,1.83,0,0,1,700.75,607.22Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.21,599.32h12.56a1,1,0,0,1,1.05,1v6.21h0a1.17,1.17,0,0,0,1.17,1.17h46.54a2,2,0,0,1-1.08.25H640.67a1.92,1.92,0,0,1-1.91-1.92v-5.65A1.83,1.83,0,0,1,639.21,599.32Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.93,606.91a.27.27,0,0,1-.28-.28v-6.77a.3.3,0,0,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.82,606.91a.28.28,0,0,1-.29-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77h0a.27.27,0,0,1-.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.69,606.91a.28.28,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.29v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.57,606.91a.28.28,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77h0a.28.28,0,0,1-.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.41,606.91a.28.28,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.29v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.33,606.91a.27.27,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.23.35v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.2,606.91a.28.28,0,0,1-.28-.28v-6.77a.29.29,0,0,1,.3-.29.3.3,0,0,1,.3.29v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.09,606.91a.28.28,0,0,1-.29-.28v-6.89a.31.31,0,0,1,.36-.23.3.3,0,0,1,.23.35v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673,606.91a.28.28,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.29v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.85,606.91a.28.28,0,0,1-.29-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.59.12v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.72,606.91a.28.28,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.29v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.59,606.91a.27.27,0,0,1-.28-.28v-6.77a.3.3,0,0,1,.59,0v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.48,606.91a.28.28,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.6,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.35,606.91a.28.28,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.3-.29.29.29,0,0,1,.3.29v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.24,606.91a.28.28,0,0,1-.29-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77h0a.27.27,0,0,1-.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.11,606.91a.28.28,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.6,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648,606.91a.28.28,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.23.35v6.77h0a.28.28,0,0,1-.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.87,606.91a.28.28,0,0,1-.29-.28v-6.77a.29.29,0,0,1,.3-.29.3.3,0,0,1,.3.29v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.75,606.91a.27.27,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.23.35v6.77h0a.28.28,0,0,1-.29.28Z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 646.84,
    y: 589.06,
    width: 62.6,
    height: 9.51,
    rx: 1.92,
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M647.24,589.83a1.84,1.84,0,0,1,1.51-.77h58.78a1.92,1.92,0,0,1,1.91,1.93v5.66a1.93,1.93,0,0,1-.87,1.6,1.9,1.9,0,0,1-1.06.31H648.75a1.9,1.9,0,0,1-1.91-1.91V591A1.76,1.76,0,0,1,647.24,589.83Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709,597.74H696.53a1,1,0,0,1-1-1v-6.21a.17.17,0,0,0,0-.07,1.16,1.16,0,0,0-1.23-1.09H647.71a2,2,0,0,1,1-.33h58.77a1.93,1.93,0,0,1,1.91,1.93v5.66A1.84,1.84,0,0,1,709,597.74Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.17,589.8h12.56a1.05,1.05,0,0,1,1.06,1.06v6.29a1.17,1.17,0,0,0,1.24,1.09h46.54a2,2,0,0,1-1.06.31H648.75a1.91,1.91,0,0,1-1.91-1.91V591A1.83,1.83,0,0,1,647.17,589.8Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.17,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,1,1,.59,0v6.83a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,1,1,.59,0v6.83a.28.28,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.93,597.47a.3.3,0,0,1-.24-.34v-6.88a.31.31,0,0,1,.36-.23.3.3,0,0,1,.23.35v6.81h0a.29.29,0,0,1-.29.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.8,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,1,1,.59,0v6.83a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.68,597.47a.29.29,0,0,1-.23-.34v-6.76a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.24.35v6.81h0a.29.29,0,0,1-.29.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.56,597.47a.3.3,0,0,1-.24-.34v-6.76a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.44,597.47a.29.29,0,0,1-.23-.34v-6.76a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.29.29,0,0,1,.23.35v6.81h0a.29.29,0,0,1-.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.31,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,0,1,.6,0v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.2,597.47a.29.29,0,0,1-.23-.34v-6.76a.24.24,0,0,1,0-.12.3.3,0,1,1,.58.12v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.07,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,0,1,.3-.3.31.31,0,0,1,.3.3v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675,597.47a.3.3,0,0,1-.24-.34v-6.88a.31.31,0,0,1,.36-.23.3.3,0,0,1,.23.35v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.83,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,1,1,.59,0v6.83a.28.28,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.7,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,0,1,.3-.3.31.31,0,0,1,.3.3v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.59,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,1,1,.59,0v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.46,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,1,1,.59,0v6.83a.28.28,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.29,597.47a.3.3,0,0,1-.23-.34v-6.76a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.22,597.47a.29.29,0,0,1-.23-.34v-6.76a.3.3,0,1,1,.59,0v6.83a.29.29,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.09,597.47a.29.29,0,0,1-.23-.34v-6.76a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.81h0a.29.29,0,0,1-.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650,597.47a.3.3,0,0,1-.23-.34v-6.76a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.83a.29.29,0,0,1-.3.27Z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 638.56,
    y: 579.61,
    width: 62.6,
    height: 9.51,
    rx: 1.92,
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M639,580.38a1.86,1.86,0,0,1,1.51-.77h58.77a1.93,1.93,0,0,1,1.91,1.94v5.66a2,2,0,0,1-.87,1.6,1.92,1.92,0,0,1-1,.31H640.47a1.92,1.92,0,0,1-1.91-1.91v-5.66A1.83,1.83,0,0,1,639,580.38Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.75,588.35H688.19a1.06,1.06,0,0,1-1.05-1.06v-6.2h0a1.17,1.17,0,0,0-1.17-1.17H639.42a2,2,0,0,1,1.05-.32h58.78a1.92,1.92,0,0,1,1.9,1.92v5.66A1.9,1.9,0,0,1,700.75,588.35Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639,580.29h12.56a1.06,1.06,0,0,1,1.05,1.06v6.28a1.17,1.17,0,0,0,1.17,1.17h46.54a1.92,1.92,0,0,1-1,.31H640.46a1.91,1.91,0,0,1-1.91-1.92v-5.65A1.82,1.82,0,0,1,639,580.29Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.93,588a.28.28,0,0,1-.28-.29V581a.3.3,0,1,1,.59,0v6.76h0a.29.29,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.82,588a.29.29,0,0,1-.29-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.3.3,0,0,1,.23.36v6.76h0a.28.28,0,0,1-.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.69,588a.29.29,0,0,1-.29-.29V581a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.57,588a.29.29,0,0,1-.28-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.3.3,0,0,1,.23.36v6.76h0a.29.29,0,0,1-.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.41,588a.29.29,0,0,1-.29-.29V581a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.33,588a.28.28,0,0,1-.28-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.31.31,0,0,1,.23.36v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.2,588a.29.29,0,0,1-.28-.29V581a.29.29,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.76h0a.29.29,0,0,1-.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.09,588a.29.29,0,0,1-.29-.29v-6.88a.3.3,0,1,1,.59.12v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673,588a.29.29,0,0,1-.29-.29V581a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.85,588a.29.29,0,0,1-.29-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.31.31,0,0,1,.24.36v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.72,588a.29.29,0,0,1-.29-.29V581a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.59,588a.28.28,0,0,1-.28-.29V581a.3.3,0,1,1,.59,0v6.76h0a.29.29,0,0,1-.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.48,588a.29.29,0,0,1-.29-.29V581a.3.3,0,0,1,.6,0v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.35,588a.29.29,0,0,1-.29-.29V581a.3.3,0,0,1,.3-.3.29.29,0,0,1,.3.3v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.24,588a.29.29,0,0,1-.29-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.3.3,0,0,1,.23.36v6.76h0a.28.28,0,0,1-.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.11,588a.29.29,0,0,1-.29-.29V581a.3.3,0,0,1,.6,0v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648,588a.29.29,0,0,1-.28-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.31.31,0,0,1,.23.36v6.76h0a.29.29,0,0,1-.28.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.87,588a.29.29,0,0,1-.29-.29V581a.29.29,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.76h0a.3.3,0,0,1-.3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.75,588a.28.28,0,0,1-.28-.29V581a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.24.31.31,0,0,1,.23.36v6.76h0a.29.29,0,0,1-.29.29Z"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 640.92,
    y: 570.17,
    width: 62.6,
    height: 9.51,
    rx: 1.92,
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M640.92,572.1a2,2,0,0,1,1.91-1.93h58.78a1.92,1.92,0,0,1,1.91,1.93v5.66a2,2,0,0,1-1.93,1.93H642.87a1.93,1.93,0,0,1-1.91-1.93V572.1Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.12,578.92h-12.5a1.06,1.06,0,0,1-1-1.06v-6.2a.22.22,0,0,0,0-.08,1.16,1.16,0,0,0-1.23-1.09H641.74a1.88,1.88,0,0,1,1-.32h58.8a1.92,1.92,0,0,1,1.93,1.92v5.66A1.93,1.93,0,0,1,703.12,578.92Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.28,570.91h12.57a1.06,1.06,0,0,1,1,1.06v6.23a1.17,1.17,0,0,0,1.18,1.15h46.54a1.88,1.88,0,0,1-1.05.32H642.83a1.91,1.91,0,0,1-1.91-1.92v-5.66A1.85,1.85,0,0,1,641.28,570.91Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700.3,578.58a.28.28,0,0,1-.28-.28v-6.77a.3.3,0,1,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.19,578.58a.29.29,0,0,1-.29-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.24.35v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.1,578.58a.29.29,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.6,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.93,578.58a.28.28,0,0,1-.28-.28v-6.77a.3.3,0,1,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.82,578.58a.29.29,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.6,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.69,578.58a.29.29,0,0,1-.29-.28v-6.77a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.57,578.58a.29.29,0,0,1-.28-.28v-6.77a.3.3,0,0,1,.3-.3.31.31,0,0,1,.3.3v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.45,578.58a.29.29,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.6,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.33,578.58a.28.28,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77h0a.29.29,0,0,1-.28.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.21,578.58a.29.29,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.3-.3.31.31,0,0,1,.3.3v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.09,578.58a.27.27,0,0,1-.28-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.58.12v6.77h0a.29.29,0,0,1-.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666,578.58a.29.29,0,0,1-.28-.28v-6.77a.3.3,0,1,1,.59,0v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.85,578.58a.29.29,0,0,1-.29-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.3.3,0,0,1,.24.35v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.72,578.58a.28.28,0,0,1-.28-.28v-6.77a.3.3,0,1,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.61,578.58a.29.29,0,0,1-.29-.28v-6.77a.24.24,0,0,1,0-.12.3.3,0,0,1,.35-.23.29.29,0,0,1,.23.35v6.77h0a.27.27,0,0,1-.29.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.48,578.58a.29.29,0,0,1-.29-.28v-6.77a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.35,578.58a.28.28,0,0,1-.28-.28v-6.77a.3.3,0,1,1,.59,0v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.24,578.58a.29.29,0,0,1-.29-.28v-6.77a.3.3,0,0,1,.3-.3.31.31,0,0,1,.3.3v6.77h0a.28.28,0,0,1-.3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.11,578.58a.29.29,0,0,1-.29-.28v-6.77a.31.31,0,0,1,.3-.3.3.3,0,0,1,.3.3v6.77h0a.28.28,0,0,1-.3.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M626.76,541.93h0a1.91,1.91,0,0,1,1.9,1.93v5.67a1.61,1.61,0,0,1,0,.31v.1a.74.74,0,0,1,0,.21,1.39,1.39,0,0,1-.12.28h0l-.08.12h0v.06a2.18,2.18,0,0,1-.46.45,1.61,1.61,0,0,1-.57.24h-2.36a1.71,1.71,0,0,1,.86.5,1.68,1.68,0,0,1,.24.29,1.84,1.84,0,0,1,.33,1v6.52a1.13,1.13,0,0,1,0,.26h0a.29.29,0,0,1,0,.13.2.2,0,0,1,0,.11.68.68,0,0,1-.07.2.29.29,0,0,0,0,.13l-.09.12v.06h0a.56.56,0,0,1-.16.21,2.34,2.34,0,0,1-.3.25h0a1.88,1.88,0,0,1-.58.26h4.28a1.92,1.92,0,0,1,1.91,1.91V569a1.6,1.6,0,0,1,0,.31v.1a.74.74,0,0,1,0,.21,1.53,1.53,0,0,1-.11.27l-.1.15h0a.72.72,0,0,1-.17.22,1.35,1.35,0,0,1-.27.2h0a.89.89,0,0,1-.29.15l-.36.12h0a1.94,1.94,0,0,1,1.56,1.88v5.73a1.13,1.13,0,0,1,0,.26h0a.33.33,0,0,1,0,.14v.13h0a.17.17,0,0,0,0,.1.37.37,0,0,1-.07.14l-.1.16h0a1.55,1.55,0,0,1-.46.46,1.88,1.88,0,0,1-.56.25h-2.4a1.91,1.91,0,0,1,1.46,1.86v6.08a.74.74,0,0,1,0,.21,1.51,1.51,0,0,1-.13.29h0l-.07.11h0v.06a1.3,1.3,0,0,1-.18.23L629,589h0a1.14,1.14,0,0,1-.31.16,2.17,2.17,0,0,1-.36.12,1.21,1.21,0,0,1-.38,0h-.68a1.75,1.75,0,0,1,.84.49,1.37,1.37,0,0,1,.24.29,1.91,1.91,0,0,1,.33,1.07v5.72a1.13,1.13,0,0,1,0,.26h0a.29.29,0,0,1,0,.13v.26h0l-.06.13-.09.12v.08h0a1.06,1.06,0,0,1-.17.2,1.28,1.28,0,0,1-.29.23h0a1.52,1.52,0,0,1-.53.25h.68a2,2,0,0,1,1.37.56,1.93,1.93,0,0,1-.08,1.21V606a1.13,1.13,0,0,1,0,.26h0v.41a.61.61,0,0,0-.07.14h0v.09l-.06.1a1.33,1.33,0,0,1-.14.19h0l-.15.15-.2.14a1.71,1.71,0,0,1-.57.25h-7.93l-.58-.32c-.26-.14-.52-.3-.77-.45q-.76-.44-1.5-.93a4.67,4.67,0,0,1-.6-.38c-.38-.25-.67-.49-1.14-.8s-.93-.65-1.39-1c-.2-.15-.4-.3-.58-.46-.84-.67-1.67-1.39-2.49-2.12l-.59-.56c-.76-.69-1.48-1.41-2.17-2.16a.82.82,0,0,1-.24-.25h-.06L608,598c-.35-.36-.79-.88-1-1.1l-.6-.67c-.83-1-1.68-2.09-2.48-3.17l-.58-.78c-.76-1-1.48-2.07-2.17-3.15l-.15-.25h0v-.06a1.65,1.65,0,0,1-.15-.25c-.72-1.08-1.33-2.16-2-3.27-.2-.34-.4-.7-.59-1.06-.81-1.49-1.58-3-2.3-4.54a1.38,1.38,0,0,1-.14-.27h0c0-.09-.08-.17-.12-.26-.24-.52-.49-1.1-.7-1.55s-.41-.92-.6-1.36c-.85-2-1.63-4-2.34-6a.32.32,0,0,1-.08-.25h0l-.09-.25c-.1-.26-.18-.44-.28-.76s-.21-.63-.31-.94c-.82-2.44-1.54-4.85-2.17-7.17l-.07-.26h0a.4.4,0,0,1-.07-.26c-.72-2.64-1.31-5.22-1.81-7.61a.79.79,0,0,1-.08-.42h0c-.07-.28-.1-.56-.17-.84a.42.42,0,0,1-.06-.25.06.06,0,0,0,0-.06h0a1,1,0,0,0,0-.25c-.12-.68-.26-1.34-.37-2-.22-1.24-.4-2.31-.6-3.52s-.34-2.35-.49-3.37v-.32Z",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 618.94,
    cy: 540.2,
    r: 30.57,
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M603.75,566.7a30.45,30.45,0,0,1-11.38-41.54l0,0a30.57,30.57,0,1,1,11.52,41.67Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.65,542.85c-.83,1.42-.43,3.18,1.85,5l3.42-6.05C613.55,541.19,611.61,541.11,610.65,542.85Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625,532.42l-3.45,6.08c2.31.54,4.2.63,5.14-1S627.09,534.17,625,532.42Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.76,517.49a24.82,24.82,0,1,0,.06,0Zm-25.3,22.45c2.69-4.76,7.5-3.63,11.82-2.39l3.92-6.91a16.5,16.5,0,0,0-6.59-1.24l.55-4.24a16.75,16.75,0,0,1,8.13,1.84l2.15-3.79,2.8,1.59-2.18,3.85c5.05,3.54,5.85,8,3.87,11.51-2.69,4.78-7.46,3.72-11.78,2.48l-3.87,6.84a15.13,15.13,0,0,0,8.31,1.24l-.42,4.32c-2.64.58-6.51-.21-10-1.9L611,557l-2.81-1.59,2.17-3.84C605.34,548,604.48,543.5,606.46,539.94Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 650.21,
    cy: 578.14,
    r: 30.62,
    transform: "translate(-71.91 1063.48) rotate(-75.55)",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 650.21,
    cy: 578.14,
    r: 30.62,
    transform: "translate(-71.91 1063.48) rotate(-75.55)",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649,586.05c1,1.37,2.75,1.74,5.34.4l-4.09-5.63C648.69,582.74,647.82,584.49,649,586.05Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.42,568.7l4.1,5.66c1.49-1.87,2.35-3.56,1.24-5.09C649.74,567.91,648,567.45,645.42,568.7Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.72,556.32a27.11,27.11,0,1,0,.06,0Zm10,32.41c-3.2-4.43-.15-8.32,2.77-11.74l-4.66-6.44a16.43,16.43,0,0,0-3.92,5.45l-3.62-2.27a16.72,16.72,0,0,1,5.06-6.62l-2.56-3.53,2.61-1.89,2.61,3.6c5.31-3.14,9.71-2,12.06,1.24,3.2,4.42.25,8.32-2.67,11.73l4.61,6.37a15.12,15.12,0,0,0,4.61-7l3.73,2.19c-.63,2.63-2.91,5.8-5.9,8.29l2.56,3.53-2.61,1.89-2.57-3.58C651.42,593,647,592,644.68,588.73Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 580.32,
    cy: 481.96,
    r: 30.57,
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 580.32,
    cy: 481.96,
    r: 30.57,
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.34,488.26c0,1.69,1.21,3,4.08,3.46v-7C576.06,485.43,574.34,486.34,574.34,488.26Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.65,472.18v7c2.27-.68,4-1.53,4-3.42S584.44,472.61,581.65,472.18Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.22,481.91h0a26.06,26.06,0,1,0,26.06-26.07A26.06,26.06,0,0,0,554.22,481.91Zm24.2,14.14c-6.17-.68-9.12-4.14-9.12-8.14,0-5.41,4.75-6.84,9.12-7.89v-7.94a16.23,16.23,0,0,0-6.37,2.12l-1.61-4a16.93,16.93,0,0,1,8-2.4v-4.37h3.23v4.45c6.13.65,9,4.09,9,8.1,0,5.46-4.68,6.88-9,7.94v7.86a15,15,0,0,0,7.85-3l1.78,4c-2,1.77-5.79,3-9.63,3.26v4.36h-3.23v-4.36Z",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M313.25,73.84a44.42,44.42,0,1,1-50.63-37.19h.08a44.35,44.35,0,0,1,50.54,37.15Z",
    fill: "#f5f5f5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M302.8,75.43a33.86,33.86,0,1,1-38.59-28.34h.08A33.8,33.8,0,0,1,302.8,75.43Z",
    fill: "#ebebeb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M302.62,74.38c-.19,0-.55-1.42-1.49-3.89a36,36,0,0,0-5.4-9.69,34.65,34.65,0,0,0-5.36-5.4A33.13,33.13,0,0,0,283,50.86a33.59,33.59,0,0,0-9.22-2.59,33,33,0,0,0-5.07-.26,33.45,33.45,0,0,0-5.18.53,34.84,34.84,0,0,0-5,1.3,30.69,30.69,0,0,0-4.64,2.1,29.58,29.58,0,0,0-4.14,2.59,31.4,31.4,0,0,0-3.56,3.06,33.87,33.87,0,0,0-5.34,6.87,35.15,35.15,0,0,0-3.09,6.92,35.78,35.78,0,0,0-1.62,11c0,2.59.18,4.12,0,4.16s-.66-1.4-1-4.11a31.29,31.29,0,0,1,.87-11.52,34.14,34.14,0,0,1,8.48-15,35.08,35.08,0,0,1,8.19-6.25,33.81,33.81,0,0,1,5-2.24A36.86,36.86,0,0,1,263,45.92a37.67,37.67,0,0,1,5.61-.55,34.43,34.43,0,0,1,5.46.32,32.8,32.8,0,0,1,5.18,1.14A31.73,31.73,0,0,1,284,48.65a33.92,33.92,0,0,1,13.21,11.07,31.77,31.77,0,0,1,4.9,10.47C302.77,72.83,302.79,74.35,302.62,74.38Z",
    fill: "#e0e0e0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.13,99.9l1,5.82-5.19.85-.94-5.65c-5.19.53-10.37-.26-13.61-2l1.8-6.78a21.2,21.2,0,0,0,10.69,2l-1.44-8.67c-6-.45-12.75-1.29-14-8.74-.91-5.5,2.3-10.88,10.37-13.18l-1-5.77,5.18-.85.93,5.65A23.71,23.71,0,0,1,281,64l-1.54,6.81a21.56,21.56,0,0,0-8.38-1.38l1.46,8.84c6,.39,12.64,1.29,13.84,8.58C287.29,92.2,284.13,97.53,276.13,99.9Zm-9-22-1.22-7.37c-2.59,1.07-3.48,2.76-3.2,4.47s2,2.46,4.42,2.81Zm11,11c-.3-1.81-2-2.59-4.33-3L275,93.09c2.5-1.09,3.42-2.61,3.14-4.29Z",
    fill: "#e0e0e0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M267.76,279.43a37,37,0,1,1-42.15-31h.07A37,37,0,0,1,267.76,279.43Z",
    fill: "#f5f5f5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259.06,280.74a28.18,28.18,0,1,1-32.12-23.6H227A28.18,28.18,0,0,1,259.06,280.74Z",
    fill: "#ebebeb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M258.91,279.86a17.37,17.37,0,0,1-1.29-3.24,30.11,30.11,0,0,0-4.45-8,28.39,28.39,0,0,0-4.46-4.51,27.66,27.66,0,0,0-6.17-3.77,25.12,25.12,0,0,0-3.68-1.3,27.18,27.18,0,0,0-8.22-1.05,29.7,29.7,0,0,0-4.31.44,27.62,27.62,0,0,0-8.08,2.81,27.95,27.95,0,0,0-13.41,16.26,30,30,0,0,0-1.37,9.07,15.57,15.57,0,0,1,0,3.48,8.62,8.62,0,0,1-.81-3.42,26.11,26.11,0,0,1,.72-9.6,28,28,0,0,1,7.06-12.48,28.87,28.87,0,0,1,6.81-5.18,28.16,28.16,0,0,1,4.16-1.87,29,29,0,0,1,9.21-1.69,30.14,30.14,0,0,1,4.55.28,27.35,27.35,0,0,1,8.18,2.46,28.45,28.45,0,0,1,6.48,4.2,29.15,29.15,0,0,1,4.52,5,26,26,0,0,1,4.12,8.69A8.24,8.24,0,0,1,258.91,279.86Z",
    fill: "#e0e0e0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M236.84,301l.8,4.84-4.33.72-.77-4.71a20.87,20.87,0,0,1-11.35-1.68l1.51-5.65a17.74,17.74,0,0,0,8.9,1.68L230.41,289c-5-.37-10.63-1.08-11.67-7.26-.75-4.59,1.92-9.08,8.64-11l-.79-4.73,4.33-.71.77,4.71a19.82,19.82,0,0,1,9.22,1.18l-1.3,5.68a18.07,18.07,0,0,0-7-1.15l1.22,7.35c5,.33,10.52,1.06,11.53,7.15C246.13,294.7,243.49,299.13,236.84,301Zm-7.49-18.4-1-6.14c-2.21.91-2.91,2.31-2.67,3.73s1.68,2.17,3.68,2.45Zm9.16,9.23c-.24-1.51-1.63-2.12-3.6-2.46l1,6C238,294.56,238.75,293.26,238.51,291.87Z",
    fill: "#e0e0e0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M630.42,250.44,404.59,180.15a11,11,0,0,1-7.25-13.78l43.44-139.5a11,11,0,0,1,13.76-7.25L680.39,89.93a11,11,0,0,1,7.22,13.77L644.18,243.21A11,11,0,0,1,630.42,250.44Z",
    fill: "#e0e0e0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M433.93,125.82l-4.27,13.74-1.4-.44,3.88-12.44-3.24-1,.41-1.3Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M444.16,142.67l-.4,1.3-9.61-3,.31-1,7.43-3.81c2-1,2.59-1.87,2.91-2.82.49-1.58-.33-2.9-2.42-3.56a4.93,4.93,0,0,0-4.22.36l-.73-1.16a6.49,6.49,0,0,1,5.47-.46c2.78.87,4.1,2.83,3.39,5.19-.41,1.29-1.18,2.36-3.58,3.59l-6.09,3.12Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M459.31,144.84l-2.74-.86-1.12,3.61-1.41-.44,1.13-3.59-7.78-2.41.41-1.07,10.09-6.82,1.57.5-9.76,6.66,5.95,1.85,1-3.17,1.37.43-1,3.17,2.74.86Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M480.31,151.39l-2.73-.86-1.13,3.6-1.43-.44,1.13-3.6-7.78-2.41.33-1,10.08-6.83,1.57.49L470.59,147l6,1.86,1-3.17,1.37.42-1,3.17,2.74.86Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M492.42,154.68c-.73,2.33-2.92,3.64-6.26,2.59a7.46,7.46,0,0,1-4.37-3.29l1-.91a6.22,6.22,0,0,0,3.7,2.89c2.34.73,3.89,0,4.45-1.68s-.22-3.21-3.69-4.28l-2.92-.91,2.84-6.66,7.5,2.33-.4,1.3-6.26-1.95-1.83,4.22,1.77.54C492.12,150.14,493.17,152.25,492.42,154.68Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M506,158.84c-.8,2.59-3.33,3.58-6,2.75-3.63-1.13-4.82-4.28-3.47-8.61,1.43-4.65,4.74-6.29,8.46-5.18a6.52,6.52,0,0,1,3,1.76l-.92,1a4.93,4.93,0,0,0-2.46-1.48c-3-.92-5.45.39-6.61,4.11-.09.31-.2.71-.29,1.13a4.58,4.58,0,0,1,4.93-1C505.37,154.13,506.77,156.32,506,158.84Zm-1.41-.4c.57-1.8-.4-3.37-2.53-4a3.31,3.31,0,0,0-4.37,1.71c0,.06-.05.13-.08.19-.46,1.51.34,3.32,2.71,4.06a3.13,3.13,0,0,0,4.13-1.57,2.67,2.67,0,0,0,.14-.36Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M524.68,164.83c-.71,2.29-2.93,3.54-6.23,2.5a7.45,7.45,0,0,1-4.38-3.29l1-.91a6.24,6.24,0,0,0,3.75,2.9c2.27.72,3.89,0,4.38-1.66s-.3-3.08-2.85-3.88l-1-.3.32-1,5.28-3.58-7-2.18.39-1.29,8.82,2.75-.31,1-5.4,3.69C524.39,160.63,525.37,162.64,524.68,164.83Z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M538.54,169c-.8,2.59-3.33,3.58-6,2.75-3.64-1.13-4.83-4.28-3.49-8.6,1.46-4.66,4.75-6.3,8.47-5.18a6.52,6.52,0,0,1,3,1.76l-.92,1a5,5,0,0,0-2.46-1.48c-3-.92-5.45.39-6.6,4.11a8.92,8.92,0,0,0-.29,1.13,4.6,4.6,0,0,1,4.92-1C537.85,164.24,539.25,166.44,538.54,169Zm-1.4-.4c.56-1.8-.41-3.37-2.53-4a3.32,3.32,0,0,0-4.38,1.69,1.67,1.67,0,0,1-.08.2c-.46,1.51.34,3.33,2.71,4.07a3.15,3.15,0,0,0,4.13-1.67l.09-.22Z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M554.1,163.26l-.32,1-9.69,10.91-1.52-.46,9.52-10.7-7.06-2.2-.8,2.59-1.39-.43,1.2-3.89Z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M573.66,169.35l-.32,1-9.68,10.93-1.53-.48,9.52-10.7-7.06-2.19-.79,2.6-1.4-.45,1.2-3.81Z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M584.06,183.44c-.75,2.43-3.28,3.29-6.54,2.28s-4.82-3.16-4.06-5.58a3.58,3.58,0,0,1,3.68-2.6,3.2,3.2,0,0,1-1.2-3.68c.68-2.24,3-3,5.92-2.14s4.4,2.91,3.71,5.19a3.28,3.28,0,0,1-3.14,2.33A3.6,3.6,0,0,1,584.06,183.44Zm-1.43-.46c.51-1.69-.6-3.21-3-4s-4.19-.14-4.72,1.54.57,3.21,3,4,4.2.15,4.72-1.54Zm-2.69-5.07c2.14.66,3.71.1,4.18-1.39s-.57-2.9-2.6-3.55-3.68-.11-4.14,1.41S577.82,177.25,579.94,177.91Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M598.36,184.43c-1.45,4.66-4.76,6.3-8.48,5.18a6.57,6.57,0,0,1-3-1.76l.92-1a5.23,5.23,0,0,0,2.47,1.48c3,.92,5.44-.39,6.61-4.11.09-.31.19-.71.28-1.13a4.6,4.6,0,0,1-4.92,1c-2.72-.84-4.12-3-3.33-5.55s3.31-3.58,6-2.75C598.52,177,599.7,180.1,598.36,184.43Zm-1.1-3.32c.48-1.51-.34-3.33-2.7-4.07a3.15,3.15,0,0,0-4.15,1.61,2.19,2.19,0,0,0-.12.33c-.56,1.79.4,3.36,2.52,4a3.31,3.31,0,0,0,4.37-1.68l.08-.21Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M614.34,182l-4.26,13.71-1.41-.44,3.89-12.46-3.23-1,.39-1.29Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M624.56,198.85l-.39,1.3-9.6-3,.31-1,7.42-3.81c2-1,2.6-1.87,2.91-2.81.49-1.59-.33-2.91-2.43-3.56a4.84,4.84,0,0,0-4.21.37l-.73-1.18a6.48,6.48,0,0,1,5.47-.44c2.78.85,4.1,2.82,3.39,5.1-.42,1.3-1.18,2.36-3.59,3.59L617,196.51Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M637.69,200c-.71,2.28-2.93,3.52-6.23,2.5a7.5,7.5,0,0,1-4.39-3.31l1-.89a6.27,6.27,0,0,0,3.75,2.9c2.27.72,3.89,0,4.38-1.66s-.31-3.08-2.85-3.88l-1-.3.33-1.05,5.27-3.57-7-2.19.39-1.29L640.2,190l-.31,1-5.43,3.73C637.39,195.82,638.35,197.8,637.69,200Z",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 578.93,
    y: 143.91,
    width: 6.23,
    height: 114.95,
    transform: "translate(216.78 697.28) rotate(-72.71)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 601.98,
    y: 192.12,
    width: 6.23,
    height: 58.95,
    transform: "translate(213.67 733.49) rotate(-72.71)",
    fill: "#fff"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.55,
    y: 77.94,
    width: 35.9,
    height: 48.05,
    rx: 6.41,
    transform: "matrix(0.3, -0.95, 0.95, 0.3, 221.1, 505.62)",
    fill: "#ebebeb"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M432.25,101.92l.69-2.2,23.7,7.37a5.19,5.19,0,1,0,3.1-9.91L436,89.79l.69-2.21L460.43,95A7.52,7.52,0,0,1,456,109.31Z",
    fill: "#e0e0e0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 471.19,
    y: 98.01,
    width: 2.31,
    height: 17.05,
    transform: "translate(229.87 525.66) rotate(-72.66)",
    fill: "#e0e0e0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 506.54,
    y: 11.9,
    width: 10.64,
    height: 124.05,
    transform: "translate(289.15 540.69) rotate(-72.71)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 631.53,
    y: 102.58,
    width: 24.97,
    height: 24.97,
    rx: 4.08,
    transform: "translate(342.74 695.78) rotate(-72.71)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M514.82,593.31l-175.58-.84a38.25,38.25,0,0,1-38.07-38.42L303,113.9a38.26,38.26,0,0,1,38.43-38.1h.05L517,76.57A38.26,38.26,0,0,1,555.11,115l-1.86,440.21a38.24,38.24,0,0,1-38.34,38.14Z",
    fill: "#3f4347"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M516.79,91.81l-34-.16-99.43-.46h-12l-29.81-.13a26.78,26.78,0,0,0-26.91,26.65h0L312.86,547.4a26.8,26.8,0,0,0,26.67,26.9h0l175.24.8a26.78,26.78,0,0,0,26.87-26.69h0l1.81-429.68A26.78,26.78,0,0,0,516.8,91.81Z",
    fill: "#fafafa"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M518.09,130.85a2.2,2.2,0,1,1-2.2-2.19h0A2.2,2.2,0,0,1,518.09,130.85Z",
    fill: "#3f4347"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M518.06,138.79a2.19,2.19,0,1,1-2.19-2.21A2.21,2.21,0,0,1,518.06,138.79Z",
    fill: "#3f4347"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M518,146.63a2.2,2.2,0,1,1-2.21-2.19h0A2.19,2.19,0,0,1,518,146.63Z",
    fill: "#3f4347"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 344.58,
    y: 205.74,
    width: 186.79,
    height: 118.5,
    rx: 5.57,
    fill: "#ebebeb"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 339.45,
    y: 198.04,
    width: 186.79,
    height: 118.5,
    rx: 5.57,
    fill: "#e0e0e0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 333.53,
    y: 191.65,
    width: 186.79,
    height: 118.5,
    rx: 5.57,
    fill: "#13674d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M364.29,218.71c0,1.52-1.21,2.4-3.52,2.4h-4.52v-8.77h4.28c2.19,0,3.32.92,3.32,2.28a2.13,2.13,0,0,1-1.17,1.93A2.15,2.15,0,0,1,364.29,218.71Zm-6-4.85v2.08h2c1,0,1.53-.35,1.53-1s-.54-1-1.53-1Zm4,4.65c0-.74-.57-1.09-1.62-1.09h-2.37v2.16h2.37C361.68,219.58,362.25,219.26,362.25,218.51Z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M371.6,219.23h-4.07l-.78,1.88h-2.09l3.89-8.77h2l3.89,8.77h-2.13Zm-.64-1.54-1.4-3.36-1.39,3.36Z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M383.46,212.34v8.77h-1.67l-4.37-5.33v5.33h-2v-8.77h1.68l4.36,5.32v-5.32Z",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M388.72,217.66l-1.18,1.3v2.22h-2V212.4h2v4.1l3.88-4.1h2.26l-3.63,3.89,3.89,4.86h-2.37Z",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M362.64,255.18H361v2.11h-.83v-2.11h-4.53v-.6l4.26-5.34h.92l-4.11,5.18h3.49v-1.85h.8v1.85h1.61Z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M368.55,255c0,1.3-1,2.39-2.92,2.39a4.23,4.23,0,0,1-2.9-1l.42-.66a3.45,3.45,0,0,0,2.48.93c1.3,0,2.08-.62,2.08-1.62s-.69-1.59-2.18-1.59H365v-.61l2.23-2.8h-4.12v-.74h5.18v.6L366,252.7C367.69,252.86,368.55,253.7,368.55,255Z",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M375.06,254.93c0,1.36-.95,2.44-2.92,2.44a4.2,4.2,0,0,1-2.89-1l.42-.66a3.4,3.4,0,0,0,2.46.93c1.37,0,2.1-.66,2.1-1.64s-.65-1.68-2.7-1.68h-1.71l.42-4h4.4V250H371l-.28,2.59h1C374.14,252.54,375.06,253.5,375.06,254.93Z",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M382.16,254.89a2.51,2.51,0,0,1-2.54,2.49h-.21c-2.14,0-3.3-1.49-3.3-4,0-2.74,1.49-4.17,3.68-4.17a3.7,3.7,0,0,1,1.9.45l-.33.66a2.74,2.74,0,0,0-1.56-.38c-1.74,0-2.85,1.12-2.85,3.31v.64a2.59,2.59,0,0,1,2.46-1.37,2.44,2.44,0,0,1,2.73,2.11C382.15,254.69,382.16,254.79,382.16,254.89Zm-.82,0c0-1.06-.79-1.74-2-1.74a1.87,1.87,0,0,0-2.06,1.65.34.34,0,0,0,0,.1c0,.9.74,1.74,2.12,1.74a1.76,1.76,0,0,0,2-1.54,1.09,1.09,0,0,0,0-.18Z",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M399.54,257.29l-1.91-2.53-1.94,2.53h-.92l2.4-3.1-2.28-2.94h.92l1.82,2.36,1.81-2.36h.91l-2.28,2.9,2.41,3.1Z",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M405.69,257.29l-2-2.53-1.93,2.53h-.92l2.4-3.1L401,251.25h.92l1.81,2.36,1.82-2.36h.89l-2.23,2.9,2.41,3.1Z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M411.83,257.29l-1.92-2.53L408,257.29h-.92l2.39-3.1-2.28-2.94h.92l1.82,2.36,1.82-2.36h.89l-2.28,2.9,2.43,3.1Z",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M418,257.29l-1.92-2.53-2,2.53h-.92l2.4-3.1-2.28-2.94h.92l1.81,2.36,1.82-2.36h.9l-2.26,2.9,2.41,3.1Z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M439.17,257.29l-1.92-2.53-1.93,2.53h-.92l2.38-3.14-2.26-2.94h.92l1.81,2.36,1.82-2.36h1l-2.35,2.94,2.42,3.1Z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M445.3,257.29l-1.92-2.53-1.93,2.53h-.92l2.4-3.1-2.28-2.94h.92l1.81,2.36,1.82-2.36h.9l-2.28,2.9,2.41,3.1Z",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M451.45,257.29l-1.92-2.53-1.93,2.53h-.92l2.42-3.14-2.28-2.94h.92l1.81,2.36,1.82-2.36h.89L450,254.15l2.41,3.1Z",
    fill: "#fff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M457.59,257.29l-1.92-2.53-1.93,2.53h-.92l2.38-3.1L453,251.25h.92l1.83,2.36,1.81-2.36h.9l-2.35,2.9,2.42,3.1Z",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M476.63,249.24v8.05h-.83V250h-1.9v-.74Z",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M483.86,255c0,1.3-1,2.39-2.91,2.39a4.25,4.25,0,0,1-2.91-1l.42-.66a3.47,3.47,0,0,0,2.49.93c1.29,0,2.07-.62,2.07-1.62s-.68-1.59-2.18-1.59h-.57v-.61l2.23-2.8h-4.12v-.74h5.19v.6l-2.27,2.86C483,252.86,483.86,253.7,483.86,255Z",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M491.88,255.18h-1.62v2.11h-.82v-2.11h-4.55v-.6l4.26-5.34h.92L486,254.42h3.49v-1.85h.8v1.85h1.63Z",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M498.08,256.56v.73h-5.65v-.55l3.35-3.27c.9-.9,1.09-1.44,1.09-2,0-.93-.67-1.5-1.9-1.5a2.68,2.68,0,0,0-2.19.89l-.59-.5a3.64,3.64,0,0,1,2.85-1.16c1.63,0,2.67.83,2.67,2.18a3.3,3.3,0,0,1-1.3,2.52l-2.73,2.69Z",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M351.53,274a2,2,0,0,1,2-2h.14a2,2,0,0,1,1.57.68l-.57.53a1.21,1.21,0,0,0-1-.45,1.22,1.22,0,0,0-1.24,1.22,1.24,1.24,0,0,0,1.23,1.24h0a1.24,1.24,0,0,0,1-.45l.57.51a1.94,1.94,0,0,1-1.59.69,2,2,0,0,1-2.07-1.86Z",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M358.25,275.1h-1.78l-.35.82h-.91l1.71-3.89h.88l1.72,3.89h-.92Zm-.28-.67-.61-1.48-.61,1.48Z",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M362.38,275.92l-.75-1.07h-.82v1.07h-.88V272h1.66c1,0,1.67.53,1.67,1.38a1.29,1.29,0,0,1-.79,1.22l.86,1.23Zm-.84-3.11h-.73v1.29h.73c.54,0,.81-.24.81-.67s-.27-.62-.81-.62Z",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M363.66,275.54l.3-.67a2.29,2.29,0,0,0,1.3.4c.53,0,.74-.17.74-.4,0-.73-2.23-.24-2.23-1.66,0-.65.53-1.2,1.62-1.2a2.64,2.64,0,0,1,1.29.34l-.27.68a2.2,2.2,0,0,0-1.06-.3c-.53,0-.74.19-.74.44,0,.7,2.24.22,2.24,1.62,0,.65-.54,1.19-1.63,1.19A2.8,2.8,0,0,1,363.66,275.54Z",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M372.62,272.08V276h-.89V274.4H370V276h-.89v-3.89H370v1.52h1.75v-1.52Z",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M373.23,274a2.1,2.1,0,1,1,2.21,2h-.11a2,2,0,0,1-2.1-1.86Zm3.31,0a1.21,1.21,0,1,0-1.21,1.23,1.18,1.18,0,0,0,1.18-1.18V274Z",
    fill: "#fff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M378.1,272.08h.9v3.11h1.92v.73H378.1Z",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M381.42,272.08h1.75a1.95,1.95,0,1,1,0,3.89h-1.75Zm1.71,3.11a1.19,1.19,0,1,0,0-2.38h-.82v2.38Z",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M388.94,275.2v.72h-3V272h2.89v.71h-2v.86h1.78v.7h-1.78v.88Z",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M392.06,275.92l-.75-1.07h-.81v1.07h-.89V272h1.66c1,0,1.68.53,1.68,1.38a1.3,1.3,0,0,1-.79,1.22l.85,1.23Zm-.84-3.11h-.72v1.29h.72c.55,0,.82-.24.82-.67s-.23-.62-.78-.62Z",
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 350.65,
    y: 285.47,
    width: 56.97,
    height: 4.93,
    rx: 2.06,
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 470.14,
    y: 285.47,
    width: 31.65,
    height: 4.93,
    rx: 2.06,
    fill: "#fff"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.13,191.65H339.72a6.18,6.18,0,0,0-6.19,6.18v31.29c11,7.69,26.15,9.08,39.58,6.24,15.83-3.31,30.17-11.41,44.91-18.05s31-11.95,46.88-9.21C480,210.69,492.77,220,506.38,227a80.3,80.3,0,0,0,14,5.63V197.83A6.19,6.19,0,0,0,514.13,191.65Z",
    fill: "#fff"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 337.43,
    y: 356.32,
    width: 48.49,
    height: 48.49,
    rx: 11.38,
    fill: "#13674d"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M366.46,388h-10.6a.61.61,0,0,1-.6-.48L351.38,372h-3.69a.65.65,0,0,1,0-1.29h4.19a.63.63,0,0,1,.61.48l3.89,15.55h10.11a.65.65,0,1,1,0,1.3Z",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 357.87,
    cy: 390.98,
    r: 1.98,
    fill: "#13674d"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M357.87,393.59a2.6,2.6,0,1,1,2.59-2.59A2.59,2.59,0,0,1,357.87,393.59Zm0-4a1.3,1.3,0,0,0,0,2.6,1.32,1.32,0,0,0,1.3-1.24A1.38,1.38,0,0,0,357.87,389.62Z",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.9,
    cy: 390.98,
    r: 1.98,
    fill: "#13674d"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M368.9,393.59a2.6,2.6,0,1,1,2.59-2.59A2.59,2.59,0,0,1,368.9,393.59Zm0-4a1.31,1.31,0,0,0-1.23,1.36,1.3,1.3,0,1,0,1.36-1.36Z",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M370.6,385.07H355.51a.61.61,0,0,1-.63-.61h0a.63.63,0,0,1,.63-.62H370l1.66-9.35h-19a.65.65,0,1,1,0-1.29h19.79a.64.64,0,0,1,.48.22.6.6,0,0,1,.13.52l-1.88,10.59A.62.62,0,0,1,370.6,385.07Z",
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 402.01,
    y: 364.84,
    width: 98.37,
    height: 11.71,
    rx: 4.89,
    fill: "#e0e0e0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 402.01,
    y: 387.85,
    width: 49.72,
    height: 11.71,
    rx: 4.89,
    fill: "#e0e0e0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M541.25,338.06c0,.18-51.19.34-114.32.34s-114.34-.16-114.34-.34,51.19-.34,114.34-.34S541.25,337.88,541.25,338.06Z",
    fill: "#e0e0e0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 353.58,
    y: 424.25,
    width: 149.12,
    height: 50.28,
    rx: 21.01,
    fill: "#13674d"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M425.2,447c0,2.59-1.9,4.09-4.93,4.09h-1.94V454h-3.14V442.9h5.08C423.3,442.9,425.2,444.48,425.2,447ZM422,447c0-1-.66-1.64-1.95-1.64h-1.75v3.22h1.75C421.37,448.59,422,448,422,447Z",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M433.61,451.86h-4.69L428,454h-3.21l4.9-11.11h3.1L437.74,454h-3.26Zm-.92-2.32L431.26,446l-1.42,3.56Z",
    fill: "#fff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M443.91,450v4h-3.13v-4l-4.24-7.08h3.32l2.59,4.42L445,442.9h3Z",
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.41,
    cy: 142.28,
    r: 9.68,
    fill: "#13674d"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 390.66,
    y: 137.3,
    width: 72.51,
    height: 8.49,
    rx: 3.55,
    fill: "#e0e0e0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 361.46,
    y: 489.03,
    width: 148.02,
    height: 9.89,
    fill: "#3f4347"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M368.47,494c1.3.44,18.64.44,18.64,34.67s-.87,76.71,17.33,78,114,0,114,0V520.73a26.05,26.05,0,0,0-25.92-26.05Z",
    fill: "#fafafa"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M368.47,494l72,.22,36.52.13h10a58.9,58.9,0,0,1,10.37.5,26.58,26.58,0,0,1,21.14,22.69,45.45,45.45,0,0,1,.24,5.71V607h-.34c-33.5.4-65.34.7-94.3.47-3.62,0-7.18-.09-10.71-.16a86.63,86.63,0,0,1-10.46-.57,11.7,11.7,0,0,1-4.69-2.2,16.86,16.86,0,0,1-3.37-3.83,34,34,0,0,1-3.89-9.07,100.16,100.16,0,0,1-3.09-18.37c-.53-5.93-.76-11.66-.89-17.12-.29-10.93,0-20.81-.2-29.47s-1.5-16.11-4.17-21.58a23.51,23.51,0,0,0-4.64-6.54,17.86,17.86,0,0,0-4.89-3.26,23.69,23.69,0,0,0-4.68-1.29l1.24.19a15.92,15.92,0,0,1,3.5,1,17.75,17.75,0,0,1,5,3.24,23.75,23.75,0,0,1,4.73,6.57c2.74,5.5,4.11,13,4.32,21.69s0,18.55.3,29.46c.14,5.45.39,11.17.93,17.1a100.61,100.61,0,0,0,3.1,18.25,33.94,33.94,0,0,0,3.81,8.91,16.77,16.77,0,0,0,3.25,3.68,11.53,11.53,0,0,0,4.45,2.09c3.32.44,6.86.41,10.37.53s7.09.13,10.71.15c28.93.2,60.79-.13,94.29-.53l-.34.34v-83.5a44.18,44.18,0,0,0-.21-5.64,25.64,25.64,0,0,0-20.65-22A59.08,59.08,0,0,0,487,495l-10-.06-36.29-.29Z",
    fill: "#3f4347"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M404.88,606.65s15,0,18.15-22.1c3.83-26.34,0-49.41,20.37-50.28s75,0,75,0v72.38Z",
    fill: "#e0e0e0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M440.89,534.53s16.43-2,16.43,25.32.43,45.36,18.62,47.37,130,0,130,0-17.77-8.37-19.07-33.08-6.48-39.77-24.28-40.24S440.89,534.53,440.89,534.53Z",
    fill: "#fafafa"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M440.89,534.53h4.33l12.46-.19,45.82-.5,31.68-.22h17.67c3,0,6.12,0,9.24.09a26.43,26.43,0,0,1,9.39,1.81,19,19,0,0,1,7.62,6.11,32.08,32.08,0,0,1,4.5,9,88.42,88.42,0,0,1,3.41,20.3c.11,1.75.2,3.5.4,5.18l.26,2.6.49,2.59.23,1.3.37,1.29.72,2.59a45.35,45.35,0,0,0,2.06,4.93A35.7,35.7,0,0,0,606.11,607l1.13.62h-4.39c-30,.49-58.59.82-84.6.81-13,0-25.36,0-36.93-.55a52.87,52.87,0,0,1-8.5-.92,17.28,17.28,0,0,1-7.38-3.72,18.1,18.1,0,0,1-4.56-6.48,34.73,34.73,0,0,1-2.19-7.26,89.74,89.74,0,0,1-1.4-14c-.17-4.44-.18-8.61-.18-12.53,0-1.94,0-3.88-.09-5.63a18,18,0,0,0-.13-2.66c-.13-.87-.21-1.71-.31-2.53l-.16-1.23c-.07-.4-.17-.79-.26-1.18-.16-.78-.35-1.54-.5-2.28l-.73-2.1-.35-1-.46-.93a15.92,15.92,0,0,0-4.31-5.77,12.68,12.68,0,0,0-4.61-2.59,12.12,12.12,0,0,0-3.22-.59h0a12.41,12.41,0,0,1,3.26.53,12.63,12.63,0,0,1,4.7,2.53,16.07,16.07,0,0,1,4.42,5.81c2.59,5,3.15,11.9,3.13,19.66,0,3.89,0,8.09.23,12.51a92.66,92.66,0,0,0,1.44,13.9,33.57,33.57,0,0,0,2.18,7.15,17.51,17.51,0,0,0,4.48,6.21,16.44,16.44,0,0,0,7.16,3.58,50.4,50.4,0,0,0,8.4.88c11.55.48,23.9.49,36.9.49,26,0,54.57-.37,84.58-.85l3.1-.07-.14.65a36.27,36.27,0,0,1-14.89-16,47.62,47.62,0,0,1-2.08-5l-.74-2.6-.36-1.29-.25-1.3-.49-2.59-.26-2.59c-.2-1.78-.29-3.52-.4-5.19A87.27,87.27,0,0,0,583,550.82a31.17,31.17,0,0,0-4.39-8.9,18.31,18.31,0,0,0-7.36-5.94,25.84,25.84,0,0,0-9.15-1.77c-3.12,0-6.2-.08-9.23-.11H535.18l-31.68.13-45.82.29-12.46.06H442Z",
    fill: "#3f4347"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M445.21,534.49c0,.08-1.3,0-3.63.27a15.68,15.68,0,0,0-8.72,4.24c-3.05,2.84-5.33,7.49-6.48,12.87s-1.3,11.57-1.52,18a89.58,89.58,0,0,1-2.1,18,43,43,0,0,1-2.68,7.48,28.06,28.06,0,0,1-3.54,6,13.67,13.67,0,0,1-8.47,5.1,16.36,16.36,0,0,1-2.71.25,4.92,4.92,0,0,1-.94,0,5,5,0,0,1,.94-.12,17.49,17.49,0,0,0,2.6-.36,15.09,15.09,0,0,0,4-1.49,14.34,14.34,0,0,0,4.2-3.67,28,28,0,0,0,3.4-5.88,45.18,45.18,0,0,0,2.59-7.41,91.44,91.44,0,0,0,2-17.91c.27-6.39.36-12.57,1.58-18.07s3.57-10.2,6.76-13.09a15.52,15.52,0,0,1,9-4.15,13.83,13.83,0,0,1,1.57-.12,11.22,11.22,0,0,1,1.16,0A5,5,0,0,1,445.21,534.49Z",
    fill: "#3f4347"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M499.76,513.82c0,.18-21,.33-46.9.33S406,514,406,513.82s21-.34,46.9-.34S499.76,513.62,499.76,513.82Z",
    fill: "#e0e0e0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M501.7,527.76c0,.19-20.31.34-45.37.34S411,528,411,527.76s20.3-.33,45.37-.33S501.7,527.58,501.7,527.76Z",
    fill: "#e0e0e0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M565.64,554.88c0,.2-21,.34-46.89.34s-46.9-.14-46.9-.34,21-.34,46.9-.34S565.64,554.71,565.64,554.88Z",
    fill: "#e0e0e0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M566.81,571.18c0,.18-19.26.33-43,.33s-43-.15-43-.33,19.26-.34,43-.34S566.81,571,566.81,571.18Z",
    fill: "#e0e0e0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 475.22,
    y: 208.07,
    width: 17.29,
    height: 17.29,
    rx: 4.08,
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 187.34,
    y: 570.87,
    width: 2.16,
    height: 46.99,
    transform: "translate(376.84 1188.72) rotate(-180)",
    fill: "#3f4347"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "245.32 648.89 245.32 629.49 188.63 617.42 134.1 629.06 134.1 653.2",
    fill: "none",
    stroke: "#9ea0a3",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "207.28 542.74 197.9 571.51 176.78 571.51 169.22 542.89 207.28 542.74",
    fill: "#9ea0a3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M106.94,377.52s8-4.53,11.86,3.88l11.85,34.49-.57,57.73-18.61,6.93-7.55-41.17Z",
    fill: "#2e3135"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M331.32,638.76l35.79,1.94s9.48,5.82-25.87,15.52c0,0-37.94,18.11-44.4-5Z",
    fill: "#13674d"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M383.27,540.47s16.63-14.57,26.28-18.24a3.8,3.8,0,0,1,4.87,5c-6,14.33-28.18,61.2-53.13,43.4Z",
    fill: "#13674d"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M295.06,581.18l.05,0a180.73,180.73,0,0,0,8.46-20.51,27.86,27.86,0,0,1,2.53-5.59c11.21-18.73,36-41.58,36-41.58,16.17-17.24-.64-21.34-.64-21.34s-46.24,31.58-45.16,71.67A42.16,42.16,0,0,1,295.06,581.18Z",
    fill: "#2f2e41"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M295.06,581.18l.05,0a180.73,180.73,0,0,0,8.46-20.51,27.86,27.86,0,0,1,2.53-5.59c11.21-18.73,36-41.58,36-41.58,16.17-17.24-.64-21.34-.64-21.34s-46.24,31.58-45.16,71.67A42.16,42.16,0,0,1,295.06,581.18Z",
    opacity: 0.2
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M317.13,515.52l42.22,28s9.7,6,23.92-3c0,0,3.67,32.34-22,30.18l-59.7-29.46S303.36,532.82,317.13,515.52Z",
    fill: "#f9b499"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M291.8,589.47l16.46,36.14s6.47,15.74,23.06,13.15c0,0-16.59,31-34.48,12.5L271.2,610.41l5.16-25.75Z",
    fill: "#f9b499"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.14 417.5 255.13 360.17 270.43 356.72 276.58 357.91 250.5 416.97 244.14 417.5",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "244.14 417.5 255.13 360.17 270.43 356.72 276.58 357.91 250.5 416.97 244.14 417.5",
    opacity: 0.2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "266.66 408.99 276.58 357.91 258.47 362.86 247.69 417.4 266.66 408.99",
    fill: "#2f2e41"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M242.24,438.47S217.3,467,203.07,459.21l-13.86-9s-4.46-14.91-4.46-28.92a9.55,9.55,0,0,0,3.45-5l16.25-7.93L219.89,426Z",
    fill: "#f7a48b"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M204.45,408.39l3.69,4.43-23.28,14.42-.11-6a13.36,13.36,0,0,0,3.45-5Z",
    fill: "#f4937d"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M209.54,406.19,188.2,416.32a9.58,9.58,0,0,1-3.45,5s-.43,27.37,12.07,43.75L166,476s-29.53,12.93-37.07-7.55l-8.19-41.6S99,380.11,127.63,368c0,0,11.86-3.88,22.2-1.08L171,371.27S199.19,371.7,209.54,406.19Z",
    fill: "#13674d"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M188.42,415.89a12.21,12.21,0,0,0,3.09-5.94c1-4.45.15-9.13-1.5-13.3a35.65,35.65,0,0,0-3.1-6,41.84,41.84,0,0,1,4.22,12.59c.57,4.32,0,9.1-2.71,12.63Z",
    opacity: 0.2
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M250.82,434.26s20.8-13.85,19.51-27.64V389s-.18-11.77-6.72-11.43a5.5,5.5,0,0,0-3.79,1.86c-2.45,2.71-7.12,9.85-.27,19.7,0,0,4.8,4.12,4,9.5a12.1,12.1,0,0,1-1,3.21s1.29,5.61-2.81,9.7C259.76,421.49,257.82,429.78,250.82,434.26Z",
    fill: "#f7a48b"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M164.71,537.89h61.86c4.53,6,3.88,77.81,3.88,77.81,45.11,4.55,59.85-17.82,64.61-34.52a56,56,0,0,0,2.21-17c-1.08-40.09,44.19-72,44.19-72l-89.24-35.78a40.62,40.62,0,0,0-34.27-.65L196.82,465,166,476c-15.09,5.38-22.23,3.86-22.23,3.86C128.43,531,164.71,537.89,164.71,537.89Z",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.54,
    cy: 654.5,
    r: 9.27,
    fill: "#9ea0a3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.32,
    cy: 654.5,
    r: 9.27,
    fill: "#9ea0a3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M170.53,359.85V375a3.76,3.76,0,0,1-.66,2.15c-1.14,1.62-4.07,3.76-11.2.79,0,0-9.7-3.88-8.84-11V342Z",
    fill: "#f9b499"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M170.53,359.85v8.62s-10.43-3.65-12.76-12.6Z",
    fill: "#f7a48b"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 152.31,
    y: 304.99,
    width: 39.44,
    height: 56.58,
    rx: 15.22,
    transform: "translate(344.07 666.56) rotate(180)",
    fill: "#f9b499"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M191.76,324.71s6.14-35.13-27.91-25.43c0,0,4.31-14.23-15.52-12.72,0,0-3.67-18.75-21.56-10.78,0,0-20,7.55-11.42,39,0,0,6,19,23.92,14.65,0,0,8.19,19,10.78,30.4V342l2.09-11.2,2.87,2.36,2.37-2.26s2.8.1,4.74,4.41c0,0,2.16-4.09-3.23-8.4,0,0,6-1.94,2.8-14.23,0,0,7.54,9.27,14.44,3.23,0,0,1.51-.86,1.29-8.4C177.42,307.47,186.69,310.49,191.76,324.71Z",
    fill: "#2f2e41"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M147,330.32h4.13a6.24,6.24,0,0,1,6.24,6.24v3.69a6.24,6.24,0,0,1-6.24,6.24H147a.42.42,0,0,1-.42-.42V330.73a.42.42,0,0,1,.42-.42Z",
    transform: "translate(303.98 676.8) rotate(180)",
    fill: "#f9b499"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M179.8,433.13l-19.22-18.36-34.26,10.32,22.44,24.64s18.53,19.83,43.54,10.13l47.85-21.12s15.52-2.16,19.61-17.25c0,0,3.88-3.23,2.81-9.7,0,0,2.71-6.34-.32-6.23a2.41,2.41,0,0,0-1.4.54c-1.92,1.51-9.75,7.83-15.42,5.37l1.58-9.39a1.2,1.2,0,0,0-1.78-1.18c-2.7,1.51-8.24,5.06-10.47,12.19,0,0-2.37,5.6-11.21,6.89Z",
    fill: "#f9b499"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M179.8,433.13a20.23,20.23,0,0,0-5.39,5,20.37,20.37,0,0,0,5.39-5Z",
    fill: "#f7a48b"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.58 414.76 165.28 419.22 138.76 438.7 126.32 425.09 160.58 414.76",
    fill: "#f7a48b"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M259.76,421.49a18.89,18.89,0,0,0-6.46,2.8,18.62,18.62,0,0,0,6.46-2.8Z",
    fill: "#f7a48b"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M262.57,411.79A42.55,42.55,0,0,1,250.49,417a19,19,0,0,0,12.08-5.18Z",
    fill: "#f7a48b"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M142.08,379.89c5.81,7.95,12.58,17,18.52,24.91l6.23,8.26.16-.49C154.16,416.44,139.3,421,126.5,425l-5.76,1.84,5.82-1.66c13.07-3.77,28.05-8.23,41-12.18-8.18-10.75-17.2-22.55-25.52-33.15Z",
    fill: "#13674d"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M142.08,379.89c5.81,7.95,12.58,17,18.52,24.91l6.23,8.26.16-.49C154.16,416.44,139.3,421,126.5,425l-5.76,1.84,5.82-1.66c13.07-3.77,28.05-8.23,41-12.18-8.18-10.75-17.2-22.55-25.52-33.15Z",
    opacity: 0.2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M261.38,379.14a50.46,50.46,0,0,0,2.84,5.33,68,68,0,0,0,3.73,6,68.62,68.62,0,0,0-3.16-6.3,63.23,63.23,0,0,0-3.63-5.66Z",
    fill: "#f4937d"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M257.5,383c1.34,2.9,2.56,5.18,4.11,8s3.26,5.65,5.05,8.29c-1.34-2.9-2.93-5.82-4.48-8.61s-2.89-5-4.68-7.66Z",
    fill: "#f4937d"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 163.74,
    y: 536.81,
    width: 68.76,
    height: 6.04,
    transform: "translate(396.23 1079.65) rotate(-180)",
    fill: "#2e3135"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M189.28,542.84H125.05s-24.58-1.29-26.52-31.46V382.26s1.94-8,8.41-4.74c0,0,5.61.86,3,11.64,0,0-6.8,32.31,3.46,57.65A45.3,45.3,0,0,0,137,471.16C150,476.94,180.69,495.36,189.28,542.84Z",
    fill: "#3f4347"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M203.83,216.13H175.1a8.84,8.84,0,0,0-8.84,8.84h0v25a8.84,8.84,0,0,0,8.83,8.85h8.37l-7,13.89,13-13.89h14.39A8.85,8.85,0,0,0,212.7,250h0V225a8.85,8.85,0,0,0-8.85-8.85Z",
    fill: "#13674d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.83,216.13H175.1a8.84,8.84,0,0,0-8.84,8.84h0v25a8.84,8.84,0,0,0,8.83,8.85h8.37l-7,13.89,13-13.89h14.39A8.85,8.85,0,0,0,212.7,250h0V225a8.85,8.85,0,0,0-8.85-8.85Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.47,
    cy: 237.37,
    r: 14.26,
    transform: "translate(-112.36 203.5) rotate(-45)",
    fill: "#13674d"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M188,243.74a1.27,1.27,0,0,1-1-.46l-5.59-6.59a1.31,1.31,0,1,1,2-1.7l4.6,5.42,7.59-9a1.31,1.31,0,0,1,2,1.7L189,243.23A1.29,1.29,0,0,1,188,243.74Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/Welcome.bbeb5cf199803162a7621f8e8e1f0277.svg";
export { ForwardRef as ReactComponent };